const serviceTerm = {
  ko:
    '<h4>이용약관</h4>' +
    '<div>' +
    '• 본 이용약관은 2023년 7월 21일부터 효력이 발생합니다.' +
    '<br>' +
    '• [2024년 10월 21일] 제19조(사용제한조치) - 포인트 사용 제한 조항 추가' +
    '<br><br><br>' +
    '' +
    '제1조(목적)' +
    '<br><br>' +
    '본 약관은 당사와 서비스를 이용하는 회원 간에 글로브웨이브 주식회사(이하 "회사"라 한다)가 제공하는 온라인 마켓플레이스 중개서비스 및 온라인 마켓플레이스 서비스 이용에 관한 권리와' +
    '의무를 규정하는 것을 목적으로 합니다.' +
    '<br><br><br>' +
    '' +
    '제2조(정의)' +
    '<br><br>' +
    '본 계약에서 사용되는 용어의 정의는 다음과 같으며, 본 계약에서 정의되지 않은 용어의 해석은 서비스 애플리케이션 내에 제공되는 관련 법률 및 별도의 지침에 따라 적용됩니다 :' +
    '<br><br>' +
    'a. "서비스"는 온라인 마켓플레이스 중개 서비스, 온라인 마켓플레이스 서비스, 커뮤니티 참여, 팬 투표 및 당사가 제공하는 기타 서비스를 의미하며, 회원 약관에 동의한 회원은' +
    '전자' +
    '시스템에 접속하여 온라인 거래를 할 수 있습니다.' +
    '<br><br>' +
    'b. "사이트"는 당사가 운영하는 온라인 상점(https://www.giftifan.com)을 말하며, 컴퓨터 및 정보 통신 시설을 사용하여 구성원에게 상품, 서비스 또는 기타' +
    '제공물을 거래에 제공합니다. 여기에는 당사가 운영하는 웹 사이트, 모바일 웹 및 애플리케이션이 포함됩니다.' +
    '<br><br>' +
    'c. "사용자"는 회사의 응용 프로그램을 다운로드하여 본 약관에 동의하고 서비스 계약을 체결한 후 서비스에 적절하게 가입하는 사용자를 말합니다.' +
    '<br><br>' +
    'd. "아이템스토어"는 회원들이 물품을 구매할 수 있는 공간을 말합니다. 당사에서 운영하는 온라인 쇼핑몰입니다.' +
    '<br><br>' +
    'e. "상품"은 앱에서 사용되는 온라인 상품을 의미하며, 서비스 화면에 유통기한 및 제한사항에 대한 자세한 내용이 표시됩니다' +
    '<br><br>' +
    'f. "사용자 정보"란 서비스 품질 유지에 필요한 필요한 정보(닉네임, 이메일)를 말합니다.' +
    '<br><br><br>' +
    '' +
    '제3조(약관의 효력)' +
    '<br><br>' +
    '당사는 본 약관에 규정되지 않은 세부적인 사항을 보완하고 운영하기 위해 개별 정책(이하 "정책"이라 한다)을 포함한 별도의 정책을 수립할 수 있습니다. 당사는 해당 정책을' +
    '웹사이트를 통해 게시할 예정입니다. 정책은 본 약관과 함께 서비스 약관(이하 "서비스 약관"이라 한다)의 일부를 구성합니다. 본 약관 및 정책에 대한 회원의 동의는 서비스 약관에' +
    '서명한 것과 동일한 효력을 갖습니다.' +
    '<br><br>' +
    '당사는 특정 서비스에 대한 약관(이하 "개별약관"이라 한다)을 별도로 제정할 수 있습니다. 회원이 개별약관에 동의하는 경우 서비스 약관의 일부를 구성합니다. 개별약관과 본 약관이' +
    '충돌하는 경우 개별약관이 적용됩니다.' +
    '<br><br><br>' +
    '' +
    '제4조(약관의 공표 및 개정)' +
    '<br><br>' +
    '당사는 회원이 쉽게 이용할 수 있도록 본 약관의 내용을 웹사이트를 통해 공개합니다.' +
    '당사는 관련 법규를 위반하지 않는 범위 내에서 본 약관 및 정책을 수정할 수 있습니다. 이 경우 당사는 시행일 7일 전부터 시행일 전일까지 홈페이지를 통해 수정된 내용 및 시행일을' +
    '공지합니다. 다만, 제안된 변경사항이 회원에게 불리한 경우 시행일 30일 전부터 시행일까지 수정된 약관 및 정책을 공지합니다.' +
    '<br><br>' +
    '당사는 관련 법령의 변경으로 인해 본 약관 또는 정책이 변경되는 등 긴급하고 부득이한 사정으로 본문에서 정하는 바에 따라 고지하기 어려운 경우 제2항과 동일한 방법으로 시행일' +
    '전까지 개정 약관 또는 정책을 공표합니다.' +
    '<br><br>' +
    '회원이 수정된 약관 또는 정책에 동의하지 않을 경우 유효일 전에 거부 의사를 표시하고 본 약관 및 정책에 근거하여 서비스 계약을 해지할 수 있습니다. 회원이 수정된 약관 또는' +
    '정책에 동의하지 않을 경우 유효일 전에 거부 의사를 표시하고 본 약관 및 정책에 근거하여 서비스 계약을 해지할 수 있습니다.' +
    '<br><br>' +
    '회사가 제2항에 따라 개정된 약관 또는 정책을 공표 또는 고지하고, 시행일 이전에 회원이 의사표시를 하지 않는 경우에는 그 의사표시를 한 것으로 간주되며, 개정된 약관 또는 정책에' +
    '동의한 것으로 간주됩니다.' +
    '당사는 본 약관의 내용은 물론 상호, 대표자명, 사업자주소, 전화번호, 이메일주소, 사업자등록번호 등을 웹사이트 초기 서비스 화면에 게시하여 회원이 쉽게 이용할 수 있도록 하여야' +
    '합니다. 당사는 홈페이지 내의 링크된 화면을 통해 회원이 본 약관에 쉽게 접근하고 검토할 수 있도록 하여야 합니다.' +
    '<br><br><br>' +
    '' +
    '' +
    '제5조(업무의 제공 및 정지)' +
    '<br><br>' +
    '본 약관에 따라 당사가 제공하는 서비스의 종류는 다음과 같습니다:' +
    '<br>' +
    '• 온라인 상거래 서비스 및 기타 관련 서비스.' +
    '<br>' +
    '• 온라인 상거래 중개 서비스 및 기타 관련 서비스.' +
    '<br>' +
    '• 위 서비스의 제공에 필요하거나 이와 관련된 부가서비스.' +
    '<br>' +
    '서비스는 일반적으로 24시간 365일 제공됩니다. 단, 업무상 또는 기술상의 어려움, 기술적 개선, 일시적인 서비스 중단, 이전 서비스의 서비스 시간 제한 등의 경우 당사는' +
    '웹사이트를 통해 변경사항을 안내할 예정입니다.' +
    '<br>' +
    '당사는 제2항의 규정에도 불구하고 서비스를 특정 범위로 구분하여 각 범위별로 별도의 운영시간을 지정할 수 있습니다. 이 경우 자세한 내용은 홈페이지를 통해 공지할 예정입니다.' +
    '<br><br>' +
    '사업부문의 변경, 사업종료, 폐업, 합병, 분할, 사업양도, 그 밖의 사유로 당사가 서비스를 제공할 수 없는 경우 당사는 해당 법령을 준수합니다. 해당 법령에서 별도로 규정하지' +
    '않는 한 회원에게는 별도의 보상이 제공되지 않습니다.' +
    '<br><br><br>' +
    '' +
    '' +
    '제6조(서비스 이용)' +
    '<br><br>' +
    '회원은 본 약관 및 서비스 화면에서 회사가 제공하는 모든 공지사항을 준수해야 합니다. 회원은 본 약관 및 제공된 공지사항을 위반하거나 준수하지 않아 발생하는 모든 손해에 대해' +
    '전적으로 책임을 집니다.' +
    '<br>' +
    '당사 또는 다른 구성원과 분쟁이 발생한 경우 구성원은 분쟁해결을 위하여 성실한 노력을 하여야 합니다. 구성원의 분쟁해결에 대한 신의가 없어 당사 또는 제3자에게 손해가 발생한' +
    '경우에는 그 손해에 대한 모든 책임을 구성원이 부담합니다.' +
    '<br><br>' +
    '당사는 회원이 거래에 사용된 결제수단을 사용할 수 있는 적절한 권한이 있는지 확인할 수 있으며, 확인이 완료될 때까지 거래를 중단할 수 있습니다.' +
    '당사는 회원에게 서비스를 안전하게 제공할 수 있도록 각종 시설 및 데이터를 관리하고, 서비스가 본인의 의도한 목적에 맞게 이용되고 있는지 확인합니다. 회원이 서비스의 의도한 목적을' +
    '위반한 것으로 확인될 경우, 당사는 회원에게 설명을 요구하고 구매 취소(선주문 포함) 등 필요한 조치를 취할 수 있습니다.' +
    '미성년자가 법적 보호자의 동의 없이 사이트를 통해 상품 또는 서비스를 구매하는 경우 미성년자 또는 법적 보호자는 계약을 취소할 수 있습니다.' +
    '<br><br><br>' +
    '' +
    '' +
    '제7조(회사의 의무)' +
    '<br><br>' +
    '당사는 본 약관에 따라 서비스를 지속적이고 안정적으로 제공하기 위해 최선의 노력을 기울여야 하며, 본 약관, 관련법 또는 공서양속에서 금지하는 행위를 하여서는 아니 됩니다.' +
    '<br>' +
    '당사는 본 약관에서 요구하는 경우를 제외하고는 회원의 동의 없이 당사에 알려진 회원의 정보를 제3자에게 제공할 수 없습니다.' +
    '<br><br>' +
    '당사는 회원의 개인정보(신용정보 포함)를 보호하고 안전한 서비스 이용을 위해 보안시스템을 구축 및 유지합니다. 당사는 개인정보 보호방침을 공개하고 준수해야 합니다.' +
    '당사는 회원의 동의 없이 영리목적의 상업용 전자메일, 앱 푸시 알림, 그 밖의 홍보물을 발송할 수 없습니다.' +
    '<br>' +
    '당사는 구성원의 의견 또는 불만사항이 객관적으로 타당하다고 인정되는 경우 불만사항 해결 및 신속한 대응을 위하여 노력하여야 하며, 신속한 처리가 어려운 경우 서비스 화면에 사유 및' +
    '처리 일정을 게시하거나 이메일, 기타 전자적 방법으로 구성원에게 통지하여야 합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제8조(회원의 의무)' +
    '<br><br>' +
    '회원은 회사의 약관, 규정, 서비스 정책, 이용 가이드라인 및 관련 법규를 준수해야 하며, 회사의 운영에 지장을 주는 행위를 하여서는 아니 됩니다.' +
    '<br>' +
    '회원은 다음 각 호의 행위를 하여서는 아니 됩니다:' +
    '<br>' +
    '• 당사가 제공하는 서비스를 이용하지 않고 구성원 간의 직거래("직거래"라 함)를 하거나 타인을 유도하는 행위.<br>' +
    '• 회사 또는 다른 구성원의 활동을 방해하거나 사이트 이용을 통해 부당이득을 취하는 등 통상의 거래관행에 부합하지 않는 부정행위를 하거나 거래행위를 하는 행위.<br>' +
    "• '여신전문금융업법', '정보통신망 이용촉진 및 정보보호 등에 관한 법률', 그 밖의 관련 법령을 위반하여 비정상적인 지급행위를 한 경우.<br>" +
    '• 회사가 제공하는 소정의 서비스 이용방법에 반하여 비정상적인 방법으로 서비스를 이용하거나 회사의 정보처리시스템에 무단으로 접속하는 행위. 회사가 제공하는 서비스와 무관한 부당한' +
    '요청이나 행위를 하거나 회사의 업무를 방해하거나 공공질서를 위반하거나 적절한 사회적 행위에 어긋나는 행위를 하는 행위.<br>' +
    '• 회사 또는 제3자의 권리를 침해하거나 침해할 우려가 있는 행위를 하거나 상거래 질서를 위협하는 행위.<br>' +
    '회원이 제2항의 규정을 위반한 경우 당사는 이용약관의 해지, 물품몰수, 회원자격 제한, 카드결제 취소 또는 정지, 그 밖의 민형사상 법률행위 등의 조치를 취할 수 있습니다. 또한' +
    '당사는 결제 게이트웨이 회사 또는 기타 계약 당사자를 통해 동일 또는 유사한 조치를 취할 수 있습니다.<br>' +
    '' +
    '<br><br><br>' +
    '' +
    '제9조(상품)' +
    '<br><br>' +
    '상품은 앱에서 사용되는 온라인 상품으로 유통기한 및 제한사항에 대한 세부사항이 서비스 화면에 표시됩니다. 상품의 가격은 환율 또는 당사의 서비스 정책에 따라 변경될 수 있습니다.' +
    '구매 후 7일이 경과된 물품은 취소 및 환불이 불가하며, 유효기간 만료 또는 회원자격 상실 시 소멸됩니다.<br>' +
    '당사가 별도로 명시하지 않는 한 타인에게 물품을 양도할 수 없으며, 불법적인 용도 또는 무단 사용으로 사용할 수 없습니다. 위반 시 당사는 물품을 무효화하고 회원의 자격을' +
    '제한하거나 해지할 수 있습니다.<br>' +
    '회원이 부정한 방법으로 물품을 취득한 것이 확인되는 경우 당사는 물품을 취소하고 회원자격 상실 및 민형사상 소송을 포함한 법적 조치를 취할 수 있습니다.' +
    '<br><br><br>' +
    '' +
    '' +
    '제10조(권리 등의 소유)' +
    '<br><br>' +
    '당사가 제공하는 서비스와 관련된 권리(데이터, 소프트웨어 및 게시물에 대한 저작권 포함)는 당사에 귀속됩니다.' +
    '' +
    '' +
    '<br><br><br>' +
    '제11조(회사의 면책조항)' +
    '<br><br>' +
    '사용자가 앱에 게시한 정보, 자료 및 사실에 대한 진실성, 정확성, 신뢰성 및 활용성뿐만 아니라 이러한 게시된 자료의 사용으로 인해 발생하는 모든 결과.' +
    '서비스를 매개로 하여 발생한 회원 간 또는 회원과 제3자 간의 분쟁.<br>' +
    '사용자가 임의로 금지된 수정사항을 변경하거나 변경된 내용을 고지하지 않은 경우 앱에 참여한 회원과 관련하여 발생할 수 있는 법적 분쟁, 책임 및 불이익.<br><br>' +
    '' +
    '사용자가 앱에 기재한 원본 내용과 회사에 제공하는 요청된 서비스 내용 간의 불일치로 인해 발생하는 모든 결과, 불이익 및 법적 책임.<br>' +
    '회사의 고의 또는 중대한 과실로 인한 것이 아닌 한 다음과 같은 상황에서 발생한 손해에 대해서는 책임을 지지 않습니다:<br>' +
    '본 약관 제6조 제2항에 따라 수행되는 서비스 제한 또는 중지 또는 본 약관에서 위임한 하위 정책.<br>' +
    '회원이 개인정보를 불완전하게 제공하거나 본 약관에 따라 필요한 정보를 업데이트하지 않아 발생한 손해.<br>' +
    '회원이 서비스에 접속하거나 이용함에 있어 고의 또는 과실이 있는 행위로 인하여 회원 또는 제3자가 입은 손해.<br>' +
    '천재지변, 전쟁, 민란, 그 밖의 불가항력적 사건으로 인하여 구성원이 입은 손해.' +
    '' +
    '<br><br><br>' +
    '' +
    '제12조(분쟁해결)' +
    '<br><br>' +
    '당사는 회원 간의 분쟁을 합리적이고 원활하게 해결하기 위해 고객센터를 운영하고 있습니다.<br>' +
    '회원은 공정성의 원칙에 입각하여 성실하게 분쟁해결절차에 참여하여야 합니다.<br><br><br>' +
    '' +
    '' +
    '' +
    '제13조(관할법·관할)' +
    '<br><br>' +
    '서비스 계약의 준거법은 대한민국의 법률입니다.<br>' +
    '서비스 계약과 관련하여 회사와 구성원 간에 발생한 분쟁이나 소송은 민사소송법에 따라 관할 법원에서 해결합니다.' +
    '' +
    '' +
    '<br><br><br>' +
    '제14조(점포약관의 정의)<br><br>' +
    '이 장에서 사용되는 용어의 정의는 이 용어의 다른 섹션과 일반적인 거래 관행에 따라 정의된 의미를 가져야 합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제15조(구매신청)<br><br>' +
    '회원은 본 약관과 유사하거나 본 약관에 규정된 방법으로 구매를 신청할 수 있습니다. 당사는 사용자가 구매를 신청하는 경우 다음 각 호의 정보를 알기 쉽게 제공해야 합니다:' +
    '<br>' +
    '• 제품 또는 품목 검색 및 선택<br>' +
    '• 수취인 이름, 주소, 전화번호, 이메일 주소(또는 휴대폰 번호) 입력(국내외 배송지의 경우 영문으로 작성해야 함)<br>' +
    '• 상품 설명, 서비스 제한, 배송비 또는 설치비 등 비용 확인<br>' +
    '• 물품 또는 물품에 대한 구매신청 확인 및 당사의 확인에 대한 동의<br>' +
    '<br><br>' +
    '당사는 다음의 경우 구매신청을 거절할 수 있습니다:<br>' +
    '• 신청서에 허위, 누락, 잘못된 정보가 있는 경우.<br>' +
    '• 미성년자가 담배나 술 등 청소년보호법에서 금지하는 재화나 용역을 구입한 경우.<br>' +
    '• 구매 신청을 수락하는 것이 회사의 기술적 능력을 현저히 저해하는 경우, 구매 대금 및 관련 책임의 지불과 관련하여 제공된 정보에 대한 전적인 책임과 불이익을 사용자가' +
    '부담합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제16조(구매취소)<br><br>' +
    '구매 취소에 대한 환불은 취소 절차가 완료되는 대로 이루어질 예정입니다.<br>' +
    '결제 중 할인쿠폰을 사용한 경우 쿠폰 사용이 취소됩니다. 단, 쿠폰이 만료된 경우 환불 즉시 무효 처리됩니다.' +
    '<br><br>' +
    '패키지로 구매한 상품의 일부를 사용할 경우 부분 환불은 불가능하며, 미사용 상태에서 7일 이내에 구매 취소의사를 밝히면, 본인인증 확인 후 환불 수수료 (환불금액의 10%)를' +
    '제외한 금액만큼 환불 처리 가능합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제17조(인도 및 거래의 완료)' +
    '<br><br>' +
    '회원은 구매한 상품 또는 물품의 인도완료일로부터 일정기간(7일) 이내에 구매, 교환, 반품 등의 의사표시를 하여야 합니다.<br>' +
    '제1항에서 정한 지정기간 내에 회원이 구매·교환·반품에 대한 의사표시를 하지 않을 경우, 회사는 회원이 자동으로 구매를 확인할 의사를 표시한 것으로 간주하여 거래에 대한 자동 구매' +
    '확인을 진행할 수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제18조(철회 등의 권리)<br><br>' +
    '회사와 재화 또는 상품의 구매에 관한 계약을 체결한 사용자는 재화 또는 상품을 공급받은 날로부터 7일 이내에 전자상거래법 등 관련법에 따라 반환 또는 교환을 신청할 수' +
    '있습니다.<br>' +
    '다만, 전자상거래법에 청약철회에 관한 구체적인 규정이 있는 경우에는 그 규정을 적용합니다.<br><br>' +
    '' +
    '회원은 제1항에도 불구하고 다음 각 호의 경우에는 반환 및 교환을 요구할 수 없습니다:<br>' +
    '• 회원의 책임으로 인하여 물품 또는 제품이 분실 또는 파손된 경우(물품 또는 제품의 내용물을 확인하기 위하여 포장이 파손된 경우는 제외합니다).<br>' +
    '• 회원의 사용 또는 부분소비로 인하여 상품 또는 상품의 가치가 현저하게 하락한 경우.<br>' +
    '• 시간의 경과로 재판매가 곤란할 정도로 재화나 상품의 가치가 현저하게 감소한 경우.<br>' +
    '• 복제 가능한 제품 또는 제품의 포장이 손상된 경우.<br>' +
    '• 문화산업진흥기본법 제2조 제5호의 서비스 또는 디지털콘텐츠의 제공이 개시된 경우(아직 계약이 개시되지 않은 분할서비스 또는 분할디지털콘텐츠로 구성된 경우는 제외).<br>' +
    '• 주문에 따라 개별적으로 생산되는 물품 또는 상품에 대하여 청약철회 등이 발생한 경우에 제조자가 회수할 수 없는 중대한 손실이 있는 경우와 이 사실을 사용자에게 별도로 통지하고' +
    '거래에 관한 사용자의 서면동의(전자문서를 포함한다)를 미리 받은 경우.<br>' +
    '' +
    '• 관련 법령에 따른 기타 반환 제한 사유가 있는 경우.<br>' +
    '' +
    '제1항 및 제2항에도 불구하고 상품 또는 상품의 내용이 표시·광고된 내용과 다르거나 약정대로 계약이 이행되지 않을 경우 회원은 상품 또는 상품을 수령한 날부터 3개월 이내 또는' +
    '회원이 그 사실을 알게 된 날부터 30일 이내에 반환 또는 교환을 신청할 수 있습니다.<br>' +
    '회원이 제1항 또는 제3항에 따라 교환을 신청하였으나 회사에 교환요청 물품의 재고가 없는 경우 회원은 물품 또는 상품에 대한 교환을 받을 수 없습니다. 이 경우 제조자는 사용자의' +
    '의사를 확인한 후 교환요청을 반환으로 처리할 수 있습니다.<br>' +
    '반품 또는 교환에 필요한 배송비 및 기타 비용은 당사자가 부담합니다. 단, 물품 또는 제품의 하자 또는 오배송으로 인한 반품 또는 교환의 경우에는 회사가 비용을 부담합니다. 회원의' +
    '단순 변심으로 인한 반품 또는 교환의 경우에는 회원이 비용을 부담합니다.<br>' +
    '회원의 반품 및 교환 요청을 회사가 거부할 경우 해당 주문은 자동으로 구매 확인서로 전환됩니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제19조(사용제한조치)' +
    '<br><br>' +
    '기프티팬을 이용하는 회원들의 쾌적하고 안전한 경험을 보장하기 위해 신고 활동을 통해 약관 및 정책을 위반하는 회원의 이용을 제한하는 조치를 시행하게 되었습니다.<br>' +
    '다음 활동으로 인해 사용 제한 조치가 발생할 수 있습니다:<br>' +
    '• 명시적인 내용의 전송 또는 게시, 불법 도박 사이트 홍보<br>' +
    '• 불법 녹음물, 허위 영상물 또는 아동 착취물 공유<br>' +
    '• 타인의 개인정보 및 권리를 공개하거나 침해하는 행위<br>' +
    '• 타인 계정 탈취• 타인에 대한 명예훼손, 폭언, 확인할 수 없는 정보 공유 등의 행위<br>' +
    '• 기타 예외적인 상황.<br>' +
    '이용 제한 조치가 적용될 경우 다음과 같은 서비스 이용 측면에서 불편을 겪을 수 있습니다.<br>' +
    ': 특정 기능 또는 전체 GIFTIFAN 서비스에 대한 액세스를 제한하거나 제한합니다.<br>' +
    '사용자가 사용제한 조치를 받으면 고객지원센터에 연락하여 조치 이유와 불편사항 해결 방법에 대한 정보를 얻으십시오.<br>' +
    '• 포인트는 본인만 사용할 수 있으며, 제3자를 대신하여 사용하거나 금전적 대가로 타인에게 제공하는 것을 금지합니다. 이를 위반할 경우, 회사는 해당 포인트를 몰수하거나 계정을 정지할 수 있으며, 서비스 이용에 제한을 둘 수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제20조 (판매상품에 대한 책임여부)' +
    '<br><br>' +
    '(주)글로브웨이브 에서 운영하는 앱/웹에서 판매하는 모든 상품은 (주)글로브웨이브 에서 책임지고 있습니다.<br>' +
    '* 민원 담당자 : 강태훈 / 070-8065-2292' +
    '<br><br>' +
    'Contact us:<br/>' +
    'Phone number: +82 10 5963 1771<br/>' +
    'Email: support@giftifan.com<br/>' +
    '<br/>' +
    'Payment is processed by third-party payment processor, Eromnet Co., Ltd, 10F, 414 Teheran-ro, Gannam-Gu, Seoul, South Korea 06193.',
  en:
    '<h4>Terms and Conditions</h4>' +
    '<div>' +
    '• These Terms of Service shall be effective from July 21, 2023.' +
    '<br>' +
    '• [October 21, 2024] Article 19 (Restrictions on Use) - Added Point Usage Restriction Clause' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 1 (Purpose)' +
    '<br><br>' +
    'These Terms and Conditions aim to define the rights and obligations regarding the use of online' +
    'marketplace intermediary services and online marketplace services provided by Globewave Co., Ltd.' +
    '(hereinafter referred to as the "Company") between the Company and the members using the services.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 2 (Definitions)' +
    '<br><br>' +
    'The definitions of terms used in this agreement are as follows, and the interpretation of terms not' +
    'defined herein shall be governed by relevant laws and separate guidelines provided within the' +
    'service application:' +
    '<br><br>' +
    '' +
    '' +
    'a. "Service" refers to online marketplace intermediary services, online marketplace services,' +
    'participating in communities, fan voting, and other services provided by the Company, allowing' +
    'members who have agreed to the membership terms and conditions to access the electronic system and' +
    'engage in online transactions.' +
    '<br><br>' +
    '' +
    '' +
    'b. "Site" refers to a virtual store (https://www.giftifan.com) operated by the Company, which uses' +
    'computer and information communication facilities to provide goods, services, or other offerings to' +
    'members for transactions. This includes the website, mobile web, and applications operated by the' +
    'Company.' +
    '<br><br>' +
    '' +
    '' +
    'c. “Users” refers to a user who downloads the company’s application program, agrees to these terms,' +
    'enters into a service contract, and properly joins the service.' +
    '<br><br>' +
    '' +
    '' +
    'd. "Item Store" refers to a space where members can purchase goods. It is an online shopping mall' +
    'operated by the Company.' +
    '<br><br>' +
    'e. "Goods" refers to online goods used in app and details regarding expiration dates and' +
    'restrictions will be displayed on the service screen.' +
    '<br><br>' +
    '' +
    '' +
    'f. “User information” refers to necessary information (nickname, email) required to maintain the' +
    'quality of the service.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 3 (Effect of Terms and Conditions)' +
    '<br><br>' +
    'The Company may establish separate policies, including individual policies (hereinafter referred to' +
    'as "Policies"), to supplement and operate detailed matters not provided for in these Terms and' +
    'Conditions. The Company will publish such Policies through the website. The Policies constitute a' +
    'part of the service agreement (hereinafter referred to as the "Service Agreement") along with these' +
    "Terms and Conditions. The Member's agreement to these Terms and Conditions and Policies shall have" +
    'the same effect as signing the Service Agreement.' +
    '<br><br>' +
    'The Company may separately establish terms and conditions (hereinafter referred to as "Individual' +
    'Terms and Conditions") for specific services. If a Member agrees to the Individual Terms and' +
    'Conditions, they will constitute a part of the Service Agreement. In the event of any conflict' +
    'between the Individual Terms and Conditions and these Terms and Conditions, the Individual Terms and' +
    'Conditions shall prevail.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 4 (Publication and Amendment of Terms and Conditions)' +
    '<br><br>' +
    'The Company shall publish the contents of these Terms and Conditions through the website to ensure' +
    'that Members can easily access them.' +
    '<br><br>' +
    'The Company may amend these Terms and Conditions and Policies within the scope not violating related' +
    'laws and regulations. In such cases, the Company will announce the amended content and the effective' +
    'date through the website, starting from 7 days prior to the effective date until the day before the' +
    'effective date. However, if the proposed changes are unfavorable to Members, the amended Terms and' +
    'Conditions and Policies will be announced from 30 days prior to the effective date until the' +
    'effective date.' +
    '<br><br>' +
    'In cases where it is difficult to provide notice as prescribed in the main text due to urgent and' +
    'unavoidable circumstances, such as changes to these Terms and Conditions or Policies due to changes' +
    'in relevant laws and regulations, the Company will publish the amended Terms and Conditions or' +
    'Policies before the effective date through the same method as described in Clause 2.' +
    '<br><br>' +
    'If a Member does not agree to the amended Terms and Conditions or Policies, they may express their' +
    'refusal before the effective date and terminate the service agreement based on these Terms and' +
    'Conditions and Policies.' +
    '<br><br>' +
    'If the Company announces or notifies the amended Terms and Conditions or Policies in accordance with' +
    'Clause 2, and the Member does not express their intention before the effective date, their intention' +
    'will be deemed as having been expressed and they will be considered to have agreed to the amended' +
    'Terms and Conditions or Policies.' +
    '<br><br>' +
    'The Company shall make the content of these Terms and Conditions, as well as its trade name, the' +
    'name of its representative, business address, telephone number, email address, and business' +
    'registration number, easily accessible to Members by posting them on the initial service screen of' +
    'the website. The Company shall ensure that Members can easily access and review these Terms and' +
    'Conditions, provided that the specific details of the Terms and Conditions may be made accessible to' +
    'Members through linked screens within the website.' +
    '' +
    '<br><br><br>' +
    '' +
    'Article 5 (Provision and Suspension of Service)' +
    '<br><br>' +
    'The types of services provided by the Company in accordance with these Terms and Conditions are as' +
    'follows:' +
    '<br><br>' +
    'Online commerce service and other associated services.' +
    '<br><br>' +
    'Online commerce intermediation service and other associated services.' +
    '<br><br>' +
    'Supplementary services necessary for the provision of the above services or related to them.' +
    '<br><br>' +
    'The service is generally available 24 hours a day, 365 days a year. However, in the event of' +
    'business or technical difficulties, technical improvements, or temporary service interruptions, or' +
    'limitations on the service hours for transfer services, the Company will provide notice of such' +
    'changes through the website.' +
    '<br><br>' +
    'Notwithstanding the provisions of Clause 2, the Company may divide the service into specific ranges' +
    'and specify separate operating hours for each range. In such cases, the details will be announced' +
    'through the website.' +
    '<br><br>' +
    'In the event that the Company is unable to provide the service due to a change in business category,' +
    'termination or abandonment of business, closure of the Company, merger, division, transfer of' +
    'business, or any other reason, the Company will comply with applicable laws and regulations. Unless' +
    'otherwise provided by applicable laws and regulations, no separate compensation will be provided to' +
    'Members in such cases.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 6 (Use of Service)' +
    '<br><br>' +
    'Members must comply with these Terms and Conditions and any notices provided by the Company on the' +
    'service screen. Members are solely responsible for any damages arising from violations or' +
    'non-compliance with these Terms and Conditions and the provided notices.' +
    '<br><br>' +
    'In the event of a dispute with the Company or other members, members must make sincere efforts to' +
    "resolve the dispute. If the member's lack of good faith in dispute resolution causes damages to the" +
    'Company or third parties, the member shall bear full responsibility for such damages.' +
    '<br><br>' +
    'The Company may verify whether a member has proper authorization to use the payment method used for' +
    'a transaction and may suspend the transaction until such verification is completed.' +
    '<br><br>' +
    'The Company manages various facilities and data to ensure the safe provision of services to members' +
    'and verifies whether the services are being used in accordance with their intended purpose. If it is' +
    'confirmed that a member has violated the intended purpose of the service, the Company may request an' +
    'explanation from the member and take necessary measures such as canceling purchases (including' +
    'pre-orders).' +
    '<br><br>' +
    'If a minor purchases goods or services through the site without the consent of their legal guardian,' +
    'the minor or legal guardian may cancel the contract.' +
    '<br><br><br>' +
    '' +
    '' +
    "Article 7 (Company's Obligations)" +
    '<br><br>' +
    'The Company shall make its best efforts to continuously and stably provide services in accordance' +
    'with these Terms and Conditions and shall not engage in any acts prohibited by these Terms and' +
    'Conditions, related laws, or public order and morals.' +
    '<br><br>' +
    "The Company shall not provide a third party with any member's information known to the Company" +
    "without the member's consent, except as required by these Terms and Conditions." +
    '<br><br>' +
    'The Company shall establish and maintain a security system to protect the personal information' +
    '(including credit information) of members and ensure their safe use of the service. The Company' +
    'shall disclose and comply with its privacy policy.' +
    '<br><br>' +
    'The Company shall not send commercial electronic emails, app push notifications, or any other' +
    "promotional materials for profit purposes without the member's consent." +
    '<br><br>' +
    "If a member's opinion or complaint is objectively recognized as valid, the Company shall make" +
    'efforts to resolve the complaint and provide a prompt response. If prompt handling is difficult, the' +
    'Company shall post the reasons and processing schedule on the service screen or notify the member by' +
    'email or other electronic means.' +
    '<br><br><br>' +
    '' +
    '' +
    "Article 8 (Member's Obligations)" +
    '<br><br>' +
    "Members shall comply with the Company's terms and conditions, regulations, service policies, usage" +
    'guidelines, and applicable laws, and shall not engage in any activities that interfere with the' +
    "Company's operations." +
    '<br><br>' +
    'Members shall not engage in the following actions:' +
    '<br><br>' +
    'Engaging in direct transactions (referred to as "direct trading") among members without utilizing' +
    'the services provided by the Company or inducing others to do so.' +
    '<br><br>' +
    'Engaging in fraudulent activities or engaging in transactions that do not conform to common trade' +
    'practices, such as disrupting the activities of the Company or other members or taking unfair' +
    'advantage through the use of the site.' +
    '<br><br>' +
    'Engaging in abnormal payment practices, in violation of the "Specialized Credit Financial Business' +
    'Act," the "Act on Promotion of Information and Communications Network Utilization and Information' +
    'Protection, etc.," and other relevant laws.' +
    '<br><br>' +
    "Using the services in an abnormal manner or accessing the Company's information processing system in" +
    'an unauthorized manner, contrary to the prescribed methods of service usage provided by the Company.' +
    '<br><br>' +
    'Engaging in unreasonable requests or actions unrelated to the services provided by the Company, or' +
    "engaging in actions that disrupt the Company's business, violate public order, or go against proper" +
    'social conduct.' +
    '<br><br>' +
    'Engaging in any act that infringes upon or poses a risk of infringing upon the rights of the Company' +
    'or third parties or threatens the order of commercial transactions.' +
    '<br><br>' +
    "In the event of a member's violation of the provisions of Paragraph 2, the Company may take the" +
    'following measures: termination of the usage agreement, confiscation of goods, restriction of member' +
    'qualifications, cancellation or suspension of card payments, and other legal actions in civil and' +
    'criminal proceedings. The Company may also take the same or similar measures through the payment' +
    'gateway company or other contracted parties with the Company.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 9 (Goods)' +
    '<br><br>' +
    'Goods is online goods used in app and details regarding expiration dates and restrictions will be' +
    'displayed on the service screen. The price of goods may be subject to change based on exchange rates' +
    "or the Company's service policies." +
    '<br><br>' +
    'Goods that have been purchased and have elapsed 7 days cannot be canceled or refunded, and they will' +
    'expire upon the expiration of their validity period or in the event of loss of membership' +
    'qualification.' +
    '<br><br>' +
    'Goods cannot be transferred to others unless otherwise specified by the Company, and they cannot be' +
    'used for illicit purposes or unauthorized uses. In the event of a violation, the Company may' +
    "invalidate the goods and restrict or terminate the member's qualifications." +
    '<br><br>' +
    'If it is confirmed that a member has acquired goods through illegitimate means, the Company may' +
    'revoke the goods and take legal actions, including the loss of membership qualifications and civil' +
    'or criminal proceedings.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 10 (Ownership of Rights, etc.)' +
    '<br><br>' +
    'Rights related to the services provided by the Company (including copyrights to data, software, and' +
    'postings) belong to the Company.' +
    '<br><br><br>' +
    '' +
    '' +
    "Article 11 (Company's Disclaimer)" +
    '<br><br>' +
    'The truthfulness, accuracy, reliability, and utilization of information, materials, and facts posted' +
    'by the user on the app, as well as any consequences arising from the use of such posted materials.' +
    '<br><br>' +
    'Disputes between members or between members and third parties arising from the use of the service as' +
    'an intermediary.' +
    '<br><br>' +
    'Legal disputes, responsibilities, and disadvantages that may arise in relation to members who have' +
    'participated in the app if the user arbitrarily changes the prohibited modifications or fails to' +
    'notify the changed content.' +
    '<br><br>' +
    'All consequences, disadvantages, and legal responsibilities arising from discrepancies between the' +
    'original contents stated by the user in the app and the requested service content provided to the' +
    'Company.' +
    '<br><br>' +
    'The Company shall not be held liable for damages arising from the following circumstances, unless it' +
    "is attributable to the Company's intentional or gross negligence:" +
    '<br><br>' +
    'Service restrictions or suspensions carried out in accordance with Article 6, Clause 2 of these' +
    'Terms and Conditions or subordinate policies delegated by these Terms and Conditions.' +
    '<br><br>' +
    "Damages caused by the member's provision of incomplete personal information, or failure to update" +
    'the required information in accordance with these Terms and Conditions.' +
    '<br><br>' +
    "Damages incurred by members or third parties due to the member's intentional or negligent acts in" +
    'accessing or using the service.' +
    '<br><br>' +
    'Damages incurred by members due to natural disasters, war, civil unrest, or other force majeure' +
    'events.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 12 (Dispute Resolution)' +
    '<br><br>' +
    'The Company operates a customer center to reasonably and smoothly resolve disputes among members.' +
    '<br><br>' +
    'Members must participate in the dispute resolution process in good faith based on the principles of' +
    'fairness.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 13 (Governing Law and Jurisdiction)' +
    '<br><br>' +
    'The governing law for the Service Agreement is the laws of the Republic of Korea.' +
    '<br><br>' +
    'Any disputes or lawsuits arising between the Company and members regarding the Service Agreement' +
    'shall be resolved in the competent court under the Civil Procedure Act.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 14 (Definition of Store Terms)' +
    '<br><br>' +
    'The definitions of terms used in this chapter shall have the meanings defined in other sections of' +
    'these terms and in accordance with general trading practices.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 15 (Purchase Application)' +
    '<br><br>' +
    'Members may apply for a purchase through methods similar to or as provided in these terms and' +
    'conditions. The Company shall provide the following information in an easily understandable manner' +
    'when a user applies for a purchase:' +
    '<br><br><br>' +
    'Searching and selecting products or items' +
    '<br><br>' +
    "Inputting the recipient's name, address, telephone number, email address (or mobile phone number)" +
    '(For delivery addresses outside of Korea, it must be written in English.)' +
    '<br><br>' +
    'Confirmation of product description, restrictions on services, and costs such as delivery fees or' +
    'installation fees' +
    '<br><br>' +
    "Confirmation of the purchase application for the goods or items and agreement to the Company's" +
    'verification' +
    '<br><br>' +
    'The Company may reject the purchase application in the following cases:' +
    '<br><br>' +
    'If there is false, omitted, or incorrect information in the application.' +
    '<br><br>' +
    'If a minor purchases goods or services prohibited by the Youth Protection Act, such as tobacco or' +
    'alcohol.' +
    '<br><br>' +
    "If accepting the purchase application would significantly hinder the Company's technological" +
    'capabilities, the user bears full responsibility and disadvantages for the information provided in' +
    'relation to the payment of the purchase price and any associated liability.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 16 (Purchase Cancellation)' +
    '<br><br>' +
    'Members may cancel a purchase until the product has been shipped. If the shipment has been' +
    'processed, the cancellation will be processed through the return procedure rather than cancellation.' +
    '<br><br>' +
    'If a member has completed the payment and the product is in the preparation stage, the cancellation' +
    'request will be processed immediately, unless there are special circumstances.' +
    '<br><br>' +
    'If a cancellation is requested while the product is in the waiting or delivery status and the' +
    'product has already been shipped, the member will generally be responsible for the round-trip' +
    'shipping cost of the shipped product. The cancellation will be processed through the return' +
    'procedure rather than cancellation.' +
    '<br><br>' +
    'Refunds for purchase cancellations will be made as soon as the cancellation process is completed.' +
    '<br><br>' +
    'If a discount coupon was used during payment, the use of the coupon will be canceled. However, if' +
    'the coupon has expired, it will be voided immediately upon refund.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 17 (Delivery and Transaction Completion)' +
    '<br><br>' +
    'A member must express their intention to confirm the purchase, exchange, or return to the company' +
    'within a certain period (7 days) from the completion of the delivery of the purchased product or' +
    'item.' +
    '<br><br>' +
    'If a member does not express their intention to confirm the purchase, exchange, or return within the' +
    'designated period specified in Clause 1, the company may consider that the member has expressed' +
    'their intention to automatically confirm the purchase, and proceed with automatic purchase' +
    'confirmation for the transaction.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 18 (Right of Withdrawal, etc.)' +
    '<br><br>' +
    'A user who has entered into a contract with the company for the purchase of goods or products may' +
    'apply for a return or exchange within 7 days from the date of receiving the goods or products, in' +
    'accordance with the relevant laws such as the Electronic Commerce Act. However, if there are' +
    'specific provisions regarding withdrawal of subscription in the Electronic Commerce Act, those' +
    'provisions shall apply.' +
    '<br><br>' +
    'Notwithstanding Clause 1, a member may not request a return or exchange under the following' +
    'circumstances :' +
    '<br><br>' +
    "• If the goods or products are lost or damaged due to the member's responsibility (excluding cases" +
    'where the packaging is damaged to check the contents of the goods or products).' +
    '<br><br>' +
    "• If the value of the goods or products has significantly decreased due to the member's use or" +
    'partial consumption.' +
    '<br><br>' +
    '• If the value of the goods or products has significantly decreased to the extent that resale is' +
    'difficult due to the passage of time.' +
    '<br><br>' +
    '• If the packaging of replicable goods or products has been damaged.' +
    '<br><br>' +
    '• If the provision of services or digital contents referred to in Article 2, Subparagraph 5 of the' +
    '"Basic Act on the Promotion of Cultural Industry" has commenced (except for cases where the contract' +
    'consists of divisible services or divisible digital contents that have not yet commenced).' +
    '<br><br>' +
    '• If there is a significant loss that cannot be recovered by the maker in the event of withdrawal of' +
    'subscription, etc. for goods or products that are individually produced according to the order, and' +
    "if the user has been separately notified of this fact and obtained the user's written consent" +
    '(including electronic documents) regarding the transaction in advance.' +
    '<br><br>' +
    '• If there are other reasons for return restriction according to relevant laws.' +
    '<br><br>' +
    'Notwithstanding Clause 1 and Clause 2, if the content of the goods or products differs from the' +
    'indicated/advertised content or the contract is not fulfilled as agreed, a member may apply for a' +
    'return or exchange within 3 months from the date of receiving the goods or products, or within 30' +
    'days from the date the member becomes aware of the fact.' +
    '<br><br>' +
    'If a member applies for an exchange according to Clause 1 or Clause 3, but the company does not have' +
    'the stock of the requested item for exchange, the member cannot receive an exchange for the goods or' +
    'products. In this case, the maker may process the exchange request as a return after confirming the' +
    "user's intention." +
    '<br><br>' +
    'The shipping fee and other costs required for return or exchange shall be borne by the party at' +
    'fault. However, in the case of return or exchange due to defects or mis delivery of the goods or' +
    "products, the company shall bear the cost. In the case of return or exchange due to the member's" +
    'simple change of mind, the member shall bear the cost.' +
    '<br><br>' +
    "If the company rejects a member's request for return or exchange, the corresponding order will be" +
    'automatically converted to a purchase confirmation.' +
    '<br><br><br>' +
    '' +
    '' +
    'Article 19 (Usage Restriction Measures)' +
    '<br><br>' +
    'To ensure a pleasant and safe experience for members using GIFTIFAN, we have implemented measures to' +
    'restrict the usage of members who violate our terms and policies through reported activities.' +
    '<br><br>' +
    'The following activities may result in usage restriction measures:' +
    '<br><br>' +
    '• Sending or posting explicit content, illegal gambling site promotions' +
    '<br><br>' +
    '• Sharing illegal recordings, false videos, or child exploitation materials' +
    '<br><br>' +
    "• Disclosing or infringing upon others' personal information and rights" +
    '<br><br>' +
    "• Hijacking others' accounts" +
    '<br><br>' +
    '• Engaging in defamation, verbal abuse, or sharing unverifiable information about others' +
    '<br><br>' +
    '• Other exceptional circumstances.' +
    '<br><br>' +
    'If usage restriction measures are applied, you may experience inconvenience in the following aspects' +
    'of service usage.' +
    '<br><br>' +
    ': Limited or restricted access to certain features or the entire GIFTIFAN service.' +
    '<br><br>' +
    'If user receive usage restriction measure, contact our customer support center and get the' +
    'information on the reason for the measure and how to resolve any inconvenience.' +
    '<br><br>' +
    '• Points can only be used by the account holder and cannot be used on behalf of others or transferred to third parties in exchange for monetary compensation. If violated, the company reserves the right to confiscate the points, suspend the account, or restrict the use of the service.' +
    '<br><br>' +
    'Contact us:<br/>' +
    'Phone number: +82 10 5963 1771<br/>' +
    'Email: support@giftifan.com<br/>' +
    '<br/>' +
    'Payment is processed by third-party payment processor, Eromnet Co., Ltd, 10F, 414 Teheran-ro, Gannam-Gu, Seoul, South Korea 06193.',
  ja:
    '● 本利用規約は2023年7月21日より有効となります。 <br/>' +
    '● [2024年10月21日] 第19条（利用制限）- ポイント使用制限条項の追加<br/><br/>' +
    '<b>第1条（目的）</b><br/>' +
    '本利用規約は、グローブウェーブ株式会社（以下「当社」という）が提供するオンラインマーケットプレイス仲介サービスおよびオンラインマーケットプレイスサービスの利用に関して、当社と会員との間の権利義務を定めることを目的とします。<br/><br/>' +
    '<b>第2条（定義）</b><br/>' +
    '本契約で使用される用語の定義は以下の通りであり、本契約で定義されていない用語の解釈は、関連法令およびサービスアプリケーション内で提供される別途のガイドラインに従うものとします：<br/>' +
    'a. 「サービス」とは、当社が提供するオンラインマーケットプレイス仲介サービス、オンラインマーケットプレイスサービス、コミュニティへの参加、ファン投票、およびその他のサービスを指し、会員規約に同意した会員が電子システムにアクセスしてオンライン取引を行うことを可能にします。<br/>' +
    'b. 「サイト」とは、当社が運営する仮想ストア（<a href="https://www.giftifan.com" style="color: mediumblue">https://www.giftifan.com</a>）を指し、コンピューターおよび情報通信設備を利用して商品、サービス、またはその他の提供物を会員に取引のために提供します。これには、当社が運営するウェブサイト、モバイルウェブ、およびアプリケーションが含まれます。<br/>' +
    'c. 「ユーザー」とは、当社のアプリケーションプログラムをダウンロードし、本規約に同意し、サービス契約を締結し、適切にサービスに加入したユーザーを指します。<br/>' +
    'd. 「アイテムストア」とは、会員が商品を購入できる空間を指します。当社が運営するオンラインショッピングモールです。<br/>' +
    'e. 「商品」とは、アプリ内で使用されるオンライン商品を指し、有効期限および制限に関する詳細はサービス画面に表示されます。<br/>' +
    'f. 「ユーザー情報」とは、サービスの品質を維持するために必要な情報（ニックネーム、メールアドレス）を指します。<br/><br/>' +
    '<b>第3条（利用規約の効力）</b><br/>' +
    '当社は、本利用規約に規定されていない詳細事項を補完し運営するために、個別のポリシーを含む別途のポリシー（以下「ポリシー」という）を設けることがあります。当社は、このようなポリシーをウェブサイトを通じて公開します。ポリシーは、本利用規約とともにサービス契約（以下「サービス契約」という）の一部を構成します。会員による本利用規約およびポリシーへの同意は、サービス契約への署名と同等の効力を持ちます。<br/>当社は、特定のサービスについて別途の利用規約（以下「個別利用規約」という）を設けることがあります。会員が個別利用規約に同意した場合、それらはサービス契約の一部を構成します。個別利用規約と本利用規約との間に矛盾がある場合は、個別利用規約が優先されます。<br/><br/>' +
    '<b>第4条（利用規約の公表および改定）</b><br/>' +
    '当社は、会員が容易にアクセスできるよう、本利用規約の内容をウェブサイトを通じて公表するものとします。<br/>' +
    '当社は、関連法令に違反しない範囲内で本利用規約およびポリシーを改定することがあります。その場合、当社は、効力発生日の7日前から効力発生日の前日までの間、ウェブサイトを通じて改定内容および効力発生日を発表します。ただし、提案された変更が会員に不利な場合は、改定された利用規約およびポリシーは効力発生日の30日前から効力発生日まで発表されます。<br/>' +
    '関連法令の変更などにより、本利用規約またはポリシーを変更する緊急かつ避けられない状況など、本文に規定されているような通知を提供することが困難な場合、当社は、第2項に記載された方法と同様の方法で、効力発生日前に改定された利用規約またはポリシーを公表します。<br/>' +
    '会員が改定された利用規約またはポリシーに同意しない場合、効力発生日前に拒否の意思を表明し、本利用規約およびポリシーに基づくサービス契約を終了することができます。<br/>' +
    '当社が第2項に従って改定された利用規約またはポリシーを公表または通知し、会員が効力発生日前に意思表示をしない場合、会員の意思は表明されたものとみなされ、改定された利用規約またはポリシーに同意したものとみなされます。<br/>' +
    '当社は、本利用規約の内容、および商号、代表者名、事業所住所、電話番号、メールアドレス、事業者登録番号を、ウェブサイトの初期サービス画面に掲載することにより、会員が容易にアクセスできるようにします。当社は、会員が本利用規約に容易にアクセスし、確認できるようにしますが、利用規約の具体的な内容については、ウェブサイト内のリンク画面を通じて会員がアクセスできるようにすることがあります。<br/><br/>' +
    '<b>第5条（サービスの提供および中断）</b><br/>' +
    '当社が本利用規約に基づいて提供するサービスの種類は以下の通りです：<br/>' +
    'オンライン商取引サービスおよびその他の関連サービス。<br/>' +
    'オンライン商取引仲介サービスおよびその他の関連サービス。<br/>' +
    '上記サービスの提供に必要な補助的サービスまたは関連サービス。<br/>' +
    'サービスは通常、年中無休で24時間利用可能です。ただし、業務上または技術上の問題、技術的改善、または一時的なサービス中断、または送金サービスの利用時間の制限がある場合、当社はウェブサイトを通じてそのような変更の通知を提供します。<br/>' +
    '第2項の規定にかかわらず、当社はサービスを特定の範囲に分割し、各範囲ごとに別個の運営時間を指定することがあります。その場合、詳細はウェブサイトを通じて発表されます。<br/>' +
    '事業種目の変更、事業の終了または放棄、会社の閉鎖、合併、分割、事業譲渡、またはその他の理由により当社がサービスを提供できなくなった場合、当社は適用法令に従うものとします。適用法令に別段の定めがない限り、そのような場合には会員に対して別途の補償は提供されません。<br/><br/>' +
    '<b>第6条（サービスの利用）</b><br/>' +
    '会員は、本利用規約およびサービス画面で当社が提供する通知に従わなければなりません。会員は、本利用規約および提供された通知の違反または不遵守から生じるいかなる損害についても単独で責任を負います。<br/>' +
    '当社または他の会員との間で紛争が発生した場合、会員は紛争解決のために誠実な努力をしなければなりません。紛争解決における会員の誠実さの欠如により当社または第三者に損害が生じた場合、会員はそのような損害に対して全責任を負うものとします。<br/>' +
    '当社は、取引に使用される支払い方法について会員が適切な権限を持っているかを確認することがあり、そのような確認が完了するまで取引を中断することがあります。<br/>' +
    '当社は、会員に安全にサービスを提供するためにさまざまな設備とデータを管理し、サービスが意図された目的に従って使用されているかを確認します。会員がサービスの意図された目的に違反したことが確認された場合、当社は会員に説明を求め、購入の取り消し（予約を含む）などの必要な措置を講じることがあります。<br/>' +
    '未成年者が法定代理人の同意なくサイトを通じて商品またはサービスを購入した場合、未成年者または法定代理人は契約を取り消すことができます。<br/><br/>' +
    '<b>第7条（会社の義務）</b><br/>' +
    '当社は、本利用規約に従って継続的かつ安定的にサービスを提供するために最善の努力を払い、本利用規約、関連法令、または公序良俗によって禁止されている行為に従事しないものとします。<br/>' +
    '当社は、本利用規約で要求される場合を除き、会員の同意なしに当社が知り得た会員の情報を第三者に提供しないものとします。<br/>' +
    '当社は、会員の個人情報（信用情報を含む）を保護し、安全なサービス利用を確保するためのセキュリティシステムを確立し維持するものとします。当社は、そのプライバシーポリシーを開示し、遵守するものとします。<br/>' +
    '当社は、会員の同意なしに営利目的の商業的電子メール、アプリのプッシュ通知、またはその他の販促資料を送信しないものとします。<br/>' +
    '会員の意見や苦情が客観的に有効であると認められる場合、当社は苦情解決に努め、迅速な対応を提供するものとします。迅速な対応が困難な場合、当社はその理由と処理スケジュールをサービス画面に掲載するか、電子メールまたはその他の電子的手段で会員に通知するものとします。<br/><br/>' +
    '<b>第8条（会員の義務）</b><br/>' +
    '会員は、当社の利用規約、規則、サービスポリシー、利用ガイドライン、および適用法令を遵守するものとし、当社の運営を妨げるいかなる活動にも従事しないものとします。<br/>' +
    '会員は以下の行為を行わないものとします：<br/>' +
    '当社が提供するサービスを利用せずに会員間で直接取引（「直接取引」と呼ぶ）を行うこと、または他者にそのような行為を促すこと。<br/>' +
    '詐欺的活動を行うこと、またはサイトの利用を通じて当社や他の会員の活動を妨害したり、不当な利益を得たりするなど、一般的な取引慣行に適合しない取引に従事すること。<br/>' +
    '「専門信用金融事業法」、「情報通信網利用促進および情報保護等に関する法律」、その他の関連法令に違反する異常な支払い行為に従事すること。<br/>' +
    '当社が提供するサービス利用の所定の方法に反して、異常な方法でサービスを利用したり、当社の情報処理システムに無断でアクセスしたりすること。<br/>' +
    '当社が提供するサービスに関連しない不合理な要求や行為を行うこと、または当社の事業を妨害したり、公序良俗に反したり、適切な社会的行動に反する行為に従事すること。<br/>' +
    '当社または第三者の権利を侵害する、または侵害するリスクがある行為、または商取引の秩序を脅かす行為に従事すること。<br/>' +
    '会員が第2項の規定に違反した場合、当社は以下の措置を講じることがあります：利用契約の解除、商品の没収、会員資格の制限、カード支払いの取り消しまたは停止、および民事・刑事訴訟における法的措置。当社は、決済代行会社または当社と契約を結んでいる他の当事者を通じて、同様またはこれに類似する措置を講じることもあります。<br/><br/>' +
    '<b>第9条（商品）</b><br/>' +
    '商品はアプリ内で使用されるオンライン商品であり、有効期限および制限に関する詳細はサービス画面に表示されます。商品の価格は、為替レートまたは当社のサービスポリシーに基づいて変更される場合があります。<br/>' +
    '購入後7日が経過した商品はキャンセルまたは返金できず、有効期限の満了または会員資格の喪失の場合に失効します。<br/>' +
    '商品は、当社が別途指定しない限り、他者に譲渡することはできず、不正目的または無断使用に使用することはできません。違反があった場合、当社は商品を無効にし、会員の資格を制限または終了することがあります。<br/>' +
    '会員が不正な手段で商品を取得したことが確認された場合、当社は商品を取り消し、会員資格の喪失および民事・刑事訴訟を含む法的措置を講じることがあります。<br/><br/>' +
    '<b>第10条（権利の所有権等）</b><br/>' +
    '当社が提供するサービスに関連する権利（データ、ソフトウェア、投稿に関する著作権を含む）は当社に帰属します。<br/><br/>' +
    '<b>第11条（会社の免責事項）</b><br/>' +
    'ユーザーがアプリに投稿した情報、資料、事実の真実性、正確性、信頼性、および利用、ならびにそのような投稿資料の利用から生じる結果について。<br/>' +
    '仲介としてのサービスの利用に起因する会員間または会員と第三者との間の紛争について。<br/>' +
    'ユーザーが禁止されている変更を任意に変更した場合、または変更された内容を通知しなかった場合に、アプリに参加した会員に関連して生じる可能性のある法的紛争、責任、および不利益について。<br/>' +
    'ユーザーがアプリで述べた元の内容と当社に提供された要求されたサービス内容との間の相違から生じるすべての結果、不利益、および法的責任について。<br/>' +
    '当社は、当社の故意または重大な過失に起因する場合を除き、以下の状況から生じる損害について責任を負わないものとします：<br/>' +
    '本利用規約の第6条第2項または本利用規約によって委任された下位政策に従って実施されるサービスの制限または停止。<br/>' +
    '会員による不完全な個人情報の提供、または本利用規約に従って必要な情報を更新しなかったことによる損害。<br/>' +
    '会員がサービスにアクセスまたは利用する際の故意または過失による行為により、会員または第三者に生じた損害。<br/>' +
    '自然災害、戦争、内乱、またはその他の不可抗力事象により会員に生じた損害。<br/><br/>' +
    '<b>第12条（紛争解決）</b><br/>' +
    '当社は、会員間の紛争を合理的かつ円滑に解決するために顧客センターを運営しています。<br/>' +
    '会員は、公平性の原則に基づいて紛争解決プロセスに誠実に参加しなければなりません。<br/><br/>' +
    '<b>第13条（準拠法および管轄）</b><br/>' +
    'サービス契約の準拠法は大韓民国の法律です。<br/>' +
    '当社と会員との間でサービス契約に関して生じるいかなる紛争または訴訟も、民事訴訟法に基づく管轄裁判所で解決されるものとします。<br/><br/>' +
    '<b>第14条（店舗用語の定義）</b><br/>' +
    '本章で使用される用語の定義は、本利用規約の他の部分で定義されている意味および一般的な取引慣行に従うものとします。<br/><br/>' +
    '<b>第15条（購入申請）</b><br/>' +
    '会員は、本利用規約に定められた方法と同様の方法または提供された方法を通じて購入を申請することができます。当社は、ユーザーが購入を申請する際に、以下の情報を分かりやすい方法で提供するものとします：<br/>' +
    '商品またはアイテムの検索と選択<br/>' +
    '受取人の氏名、住所、電話番号、メールアドレス（または携帯電話番号）の入力（韓国以外の配送先住所の場合は、英語で記入する必要があります）<br/>' +
    '商品の説明、サービスの制限、配送料やインストール料などのコストの確認<br/>' +
    '商品またはアイテムの購入申請の確認および当社の確認への同意<br/>' +
    '当社は、以下の場合に購入申請を拒否することがあります：<br/>' +
    '申請内容に虚偽、省略、または不正確な情報がある場合。<br/>' +
    '未成年者がタバコやアルコールなど、青少年保護法で禁止されている商品やサービスを購入する場合。<br/>' +
    '購入申請を受け入れることが当社の技術的能力を著しく妨げる場合、ユーザーは購入価格の支払いに関連して提供した情報および関連する責任について全責任を負います。<br/><br/>' +
    '<b>第16条（購入キャンセル）</b><br/>' +
    '会員は、商品が発送されるまで購入をキャンセルすることができます。発送が処理された場合、キャンセルはキャンセルではなく返品手続きを通じて処理されます。<br/>' +
    '会員が支払いを完了し、商品が準備段階にある場合、特別な事情がない限り、キャンセル要求は直ちに処理されます。<br/>' +
    '商品が待機中または配送中の状態でキャンセルが要求され、商品がすでに発送されている場合、会員は一般的に発送された商品の往復送料を負担するものとします。キャンセルはキャンセルではなく返品手続きを通じて処理されます。<br/>' +
    '購入キャンセルの返金は、キャンセル処理が完了次第行われます。<br/>' +
    '支払い時に割引クーポンが使用された場合、クーポンの使用はキャンセルされます。ただし、クーポンの有効期限が切れている場合は、返金時に直ちに無効となります。<br/><br/>' +
    '<b>第17条（配送および取引完了）</b><br/>' +
    '会員は、購入した商品またはアイテムの配送完了から一定期間（7日間）以内に、購入確認、交換、または返品の意思を当社に表明する必要があります。<br/>' +
    '会員が第1項で指定された期間内に購入確認、交換、または返品の意思を表明しない場合、当社は会員が自動的に購入確認の意思を表明したと見なし、取引の自動購入確認を進めることがあります。<br/><br/>' +
    '<b>第18条（撤回権等）</b><br/>' +
    '商品または製品の購入に関して当社と契約を締結したユーザーは、電子商取引法などの関連法に従い、商品または製品を受け取った日から7日以内に返品または交換を申請することができます。ただし、電子商取引法に購読撤回に関する特定の規定がある場合は、それらの規定が適用されます。<br/>' +
    '第1項にかかわらず、会員は以下の状況において返品または交換を要求することはできません：<br/>' +
    '<div style="padding-left: 1rem">● 会員の責任により商品または製品が紛失または損傷した場合（商品または製品の内容を確認するための包装の損傷を除く）。<br/>' +
    '● 会員の使用または部分的な消費により商品または製品の価値が著しく低下した場合。<br/>' +
    '● 時間の経過により商品または製品の価値が再販が困難なほど著しく低下した場合。<br/>' +
    '● 複製可能な商品または製品の包装が損傷した場合。<br/>' +
    '● 「文化産業振興基本法」第2条第5項に規定されるサービスまたはデジタルコンテンツの提供が開始された場合（契約が未開始の分割可能なサービスまたは分割可能なデジタルコンテンツで構成される場合を除く）。<br/>' +
    '● 注文に応じて個別に製造された商品または製品について、購読撤回等の場合にメーカーに回復不可能な重大な損失が生じる場合であって、ユーザーがこの事実を事前に別途通知され、取引に関するユーザーの書面による同意（電子文書を含む）を得ている場合。<br/>' +
    '● 関連法による返品制限の他の理由がある場合。</div>' +
    '第1項および第2項にかかわらず、商品または製品の内容が表示/広告内容と異なる場合、または契約が合意通りに履行されていない場合、会員は商品または製品を受け取った日から3ヶ月以内、または会員がその事実を知った日から30日以内に返品または交換を申請することができます。<br/>' +
    '会員が第1項または第3項に従って交換を申請したが、当社に交換を要求された商品の在庫がない場合、会員は商品または製品の交換を受けることができません。この場合、メーカーはユーザーの意思を確認した後、交換要求を返品として処理することがあります。<br/>' +
    '返品または交換に必要な送料およびその他の費用は、過失のある当事者が負担するものとします。ただし、商品または製品の欠陥または誤配送による返品または交換の場合は、当社が費用を負担するものとします。会員の単純な気持ちの変化による返品または交換の場合、会員が費用を負担するものとします。<br/>' +
    '当社が会員の返品または交換要求を拒否した場合、対応する注文は自動的に購入確認に変換されます。<br/><br/>' +
    '<b>第19条（利用制限措置）</b><br/>' +
    'GIFTIFANを利用する会員に快適で安全な体験を提供するため、報告された活動を通じて当社の利用規約やポリシーに違反する会員の利用を制限する措置を実施しています。<br/>' +
    '以下の活動は、利用制限措置の対象となる可能性があります：<br/>' +
    '<div style="padding-left: 1rem">● 露骨なコンテンツ、違法なギャンブルサイトの宣伝の送信または投稿<br/>' +
    '● 違法な録音、虚偽の動画、または児童搾取材料の共有<br/>' +
    '● 他者の個人情報および権利の公開または侵害<br/>' +
    '● 他者のアカウントの乗っ取り<br/>' +
    '● 名誉毀損、暴言、または他者に関する確認できない情報の共有<br/>' +
    '● その他の例外的な状況</div>' +
    '利用制限措置が適用された場合、サービス利用の以下の側面で不便を経験する可能性があります。<br/>' +
    ': 特定の機能またはGIFTIFANサービス全体へのアクセスの制限または制約。<br/>' +
    '利用制限措置を受けた場合は、当社のカスタマーサポートセンターに連絡し、措置の理由および不便を解決する方法について情報を得てください。' +
    '<div style="padding-left: 1rem">● ポイントはアカウント所有者のみが使用でき、他者に代わって使用したり、金銭的補償と引き換えに第三者に譲渡したりすることはできません。違反した場合、当社はポイントを没収し、アカウントを停止し、またはサービスの使用を制限する権利を留保します。</div>' +
    '<br/>' +
    'お問い合わせ先： 電話番号：+82 10 5963 1771 メールアドレス：<a href="mailto:support@giftifan.com">support@giftifan.com</a><br/>' +
    '決済は第三者決済処理業者であるエロムネット株式会社（韓国ソウル市江南区テヘラン路414、10階、06193）によって処理されます。',
};

const privacyTerm = {
  ko:
    '<h4>개인정보 처리방침</h4>' +
    '<br><br>' +
    '<div>' +
    '제1조(목적)' +
    '<br><br>' +
    '글로브웨이브 주식회사(이하 "회사"라 한다)는 회사가 제공하고자 하는 서비스(이하 "회사서비스"라 한다)를 이용하는 개인(이하 "이용자" 또는 "개인"이라 한다)의 정보(이하' +
    '"개인정보"라 한다)를 보호합니다. 개인정보보호법 및 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"이라 한다) 등 관련 법령을 준수하고 개인정보보호와 관련된' +
    '서비스 이용자의 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침(이하 "이 방침"이라 한다)을 수립합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제2조(개인정보처리의 원칙)' +
    '<br><br>' +
    '개인정보 관련 법률 및 본 정책에 따라 회사는 이용자의 개인정보를 수집할 수 있으며, 수집된 개인정보는 개인의 동의가 있어야 제3자에게 제공할 수 있습니다. 단, 법률 및 규정' +
    '등에 의해 법적으로 시행되는 경우 회사는 수집된 이용자의 개인정보를 개인의 사전 동의 없이 제3자에게 제공할 수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제3조(이 규정의 공시)' +
    '<br><br>' +
    '1. 회사는 이용자가 언제든지 쉽게 이 정책을 확인할 수 있도록 회사 홈페이지의 첫 화면이나 첫 화면 링크를 통해 이 정책을 공개합니다.' +
    '<br>' +
    '2. 회사는 제1항에 따라 본 정책을 공개할 때, 이용자가 본 정책을 쉽게 확인할 수 있도록 글꼴 크기, 색상 등을 사용합니다.' +
    '<br><br><br>' +
    '' +
    '제4조(이 정책의 변경)' +
    '<br><br>' +
    '1. 본 정책은 개인정보 관련 법령, 지침, 고시 또는 정부 또는 회사 서비스의 정책이나 내용 등의 변경에 따라 개정될 수 있습니다.' +
    '<br>' +
    '2. 회사는 제1항에 따라 본 약관을 개정하는 경우 다음 중 하나 이상의 방법으로 고시할 예정입니다.' +
    '<br>' +
    'a. 당사 인터넷 홈페이지 첫 화면의 공지란을 통해 공지하거나 별도의 창을 통해 공지하는 방법 <br>' +
    'b. 서면, 팩시밀리, 이메일 또는 이와 유사한 방법으로 이용자에게 통지하는 방법. <br>' +
    '3. 당사는 본 정책의 개정 시행일 최소 7일 전에 제2항에 공고할 예정입니다. 다만, 이용자 권리에 중대한 변동이 있는 경우에는 최소 30일 전에 공고할 예정입니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제5조(회원가입을 위한 정보) <br><br>' +
    '회사는 이용자가 회사의 서비스를 등록할 수 있도록 하기 위해 다음과 같은 정보를 수집합니다. <br>' +
    '1. 필수수집정보 : 이메일주소 및 닉네임 <br><br><br>' +
    '' +
    '' +
    '' +
    '제6조(회사의 서비스 제공을 위한 정보)<br><br>' +
    '회사는 이용자에게 회사의 서비스를 제공하기 위해 다음과 같은 정보를 수집합니다. <br>' +
    '1. 필수수집정보 : 아이디 및 이메일주소 <br>' +
    '' +
    '' +
    '' +
    '제7조(서비스 이용 및 부정 이용 확인을 위한 정보) <br><br>' +
    '당사는 이용자의 서비스 이용 및 서비스 오용을 확인하고 분석하기 위해 다음과 같은 정보를 수집합니다. <br>' +
    '1. 필수수집정보 : 서비스 이용기록 <br>' +
    '※ 무단사용 : 회원가입을 철회한 후 반복적으로 재가입을 하거나 상품을 구매한 후 구매를 취소하는 등 회사가 제공하는 할인쿠폰이나 이벤트 혜택 등 경제적 이익을 불법 또는 불법으로' +
    '제공받는 행위, 이용약관 등에서 금지하는 행위, 개인정보 도용 등 불법·불법행위를 말합니다. 수집된 정보는 회사 서비스 이용에 기반한 통계 및 분석에 활용될 수 있습니다.' +
    '<br><br><br>' +
    '' +
    '' +
    '' +
    '제8조(개인정보 수집방법) <br><br>' +
    '회사는 다음과 같은 방법으로 이용자의 개인정보를 수집합니다. <br>' +
    '1. 이용자가 회사 홈페이지에 개인정보를 입력하는 방법 <br>' +
    '2. 이용자가 애플리케이션 등 회사가 제공하는 웹사이트 이외의 서비스를 통하여 개인정보를 입력하는 방법. <br><br><br>' +
    '' +
    '' +
    '' +
    '제9조(개인정보의 이용) <br><br>' +
    '당사는 다음의 경우 개인정보를 활용합니다. <br>' +
    '1. 이용문의 대응, 민원처리 등 이용자를 위한 서비스 개선 <br>' +
    '2. 회사의 서비스 제공 <br>' +
    '3. 인구통계학적 분석, 서비스 방문 및 이용 기록 분석 <br>' +
    '4. 법령 및 회사약관을 위반한 회원의 이용제한, 부정사용 등 서비스의 원활한 운영을 방해하는 행위를 예방하고 제재하기 위함입니다. <br><br><br>' +
    '' +
    '' +
    '' +
    '제10조(개인정보의 보유 및 이용기간) <br><br>' +
    '1. 당사는 개인정보 수집 및 이용 목적을 달성하기 위하여 이용자의 개인정보를 해당 기간 동안 보유·이용합니다. <br>' +
    '2. 전항에도 불구하고 회사 내부 방침에 따라 불법적인 서비스 이용 기록은 회원 탈퇴 시점부터 최대 1년간 보관하여 불법 등록 및 이용을 방지하고 있습니다. <br><br><br>' +
    '' +
    '' +
    '' +
    '제11조(개인정보의 법에 따른 보유 및 이용기간) <br><br>' +
    '당사는 관련 법규에 따라 아래와 같이 개인정보를 보유 및 이용하고 있습니다. <br>' +
    '1. 전자상거래 등에서의 소비자보호에 관한 법률에 따른 정보 및 보유기간. <br>' +
    '<br>' +
    '계약 또는 청약취소 등에 관한 기록 : 5년' +
    '<br>' +
    'b. 물품대금지급 및 공급실적 등: 5년 <br>' +
    'c. 소비자불만 또는 분쟁해결 실적 : 3년 <br>' +
    'd. 표시 및 광고 관련 기록 : 6개월 <br>' +
    '' +
    '2. 통신비밀보호법에 따른 정보의 보유 및 보유기간2. 통신비밀보호법에 따른 정보의 보유 및 보유기간' +
    '<br>' +
    'a. 웹사이트 로그 자료 : 3개월' +
    '<br>' +
    '3. 전자금융거래법에 따른 정보 및 보유기간 <br>' +
    'a. 전자금융거래 실적: 5년 <br>' +
    '' +
    '4. 위치정보 등의 보호 및 이용에 관한 법률. <br>' +
    'a. 개인위치정보 기록 : 6개월 <br>' +
    '' +
    '' +
    '' +
    '제12조(개인정보 파기의 원칙) <br><br>' +
    '이용자의 개인정보 처리 목적을 달성하였거나 보유·이용 기간이 만료된 경우 등 더 이상 개인정보가 필요하지 않을 때는 지체 없이 파기하는 것을 원칙으로 합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제13조(서비스 미이용자에 대한 개인정보 처리) <br><br>' +
    '1. 회사는 1년 동안 회사의 서비스를 이용하지 않은 이용자의 개인정보를 이용자에게 미리 공지하고 개인정보를 별도로 파기 또는 보관하는 것을 원칙으로 합니다. <br>' +
    '2. 당사는 장기간 사용하지 않은 이용자의 개인정보를 별도로 안전하게 보관하며, 이러한 이용자의 알림은 분리 및 처리일 최소 30일 전에 해당 이용자의 이메일 주소로 발송됩니다.' +
    '<br>' +
    "3. 장기간 서비스를 이용하지 않은 이용자는 회사가 비이용자용 DB를 분리하기 전에 서비스를 계속 이용하고자 할 경우 홈페이지('모바일 앱' 포함)에 로그인할 수 있습니다." +
    '<br>' +
    '4. 장기간 서비스를 이용하지 않은 이용자는 홈페이지 로그인 시 이용자 동의 하에 계정을 복원할 수 있습니다. <br>' +
    '5. 회사는 별도로 보관된 개인정보를 4년간 보관한 후 지체 없이 파기합니다. <br>' +
    '' +
    '<br><br><br>' +
    '' +
    '제14조(개인정보 파기절차) <br><br>' +
    '1. 회원가입 등을 위해 이용자가 입력한 정보는 개인정보처리 목적 달성 후 별도 DB(종이의 경우 별도의 서류함)로 이관되어 내부방침 및 기타 관련 법규에 따라 보관(보관 및' +
    '보관)합니다. (이용기간 참조) 일정기간 보관 후 파기합니다. <br>' +
    '2. 회사는 개인정보보호관리자의 승인 절차를 거쳐 파기사유가 있는 개인정보를 파기합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제15조(개인정보의 파기방법) <br><br>' +
    '당사는 기록을 복구할 수 없게 만드는 기술적 방법을 사용하여 전자 파일 형식으로 저장된 개인 정보를 삭제하고, 종이에 인쇄된 개인 정보는 파쇄 또는 소각하여 파기합니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제16조(광고정보의 전송조치) <br><br>' +
    '1. 전자송신매체를 이용하여 상업적 목적으로 광고성 정보를 전송하는 경우 회사는 이용자의 명시적인 사전 동의를 얻지만, 다음 각 호의 어느 하나에 해당하는 경우에는 사전 동의를' +
    '얻지 않습니다:' +
    '<br>' +
    '상품 등에 대한 거래관계를 통해 수취인으로부터 직접 연락처를 수집하는 경우 거래 종료일로부터 6개월 이내에 처리하고 수취인과 거래한 상품과 동일한 유형의 상품에 대한 영리광고' +
    '정보를 전송하고자 합니다' +
    '<br>' +
    'b. 방문판매 등에 관한 법률에 의한 전화권유판매업자가 수신자에게 개인정보수집의 출처를 알리고 전화권유를 한 경우.' +
    '<br>' +
    '2. 전항에도 불구하고 수신인이 수신거부 의사를 표시하거나 사전동의를 철회하는 경우 당사는 상업적 목적으로 광고성 정보를 전송하지 않으며, 수신인에게 정보 수신거부 또는 동의' +
    '철회에 대한 처리결과를 통보할 예정입니다. <br>' +
    '3. 제1항에도 불구하고 당사가 오후 9시부터 다음날 오전 8시 사이에 전자송신매체를 이용하여 상업적 목적의 광고성 정보를 전송하는 경우에는 수신자로부터 별도의 사전 동의를' +
    '받습니다. <br>' +
    '4. 당사는 전자송신매체를 이용하여 상업적 목적으로 광고정보를 전송하는 경우, 광고정보에 다음과 같은 내용을 구체적으로 공시합니다. 2. 전항에도 불구하고 수신인이 수신거부 의사를' +
    '표시하거나 사전동의를 철회하는 경우 당사는 상업적 목적으로 광고성 정보를 전송하지 않으며, 수신인에게 정보 수신거부 또는 동의 철회에 대한 처리결과를 통보할 예정입니다. <br>' +
    '' +
    'a. 회사명 및 연락처 <br>' +
    '' +
    'b. 접수거부 또는 접수동의 철회에 관한 사항의 표시. <br>' +
    '' +
    '5. 전자전송매체를 이용하여 상업적 목적으로 광고성 정보를 전송하는 경우 당사는 다음 각 호의 어느 하나에 해당하는 조치를 취하지 않습니다. <br>' +
    '' +
    'a. 광고성 정보 수신자가 수신을 거부하거나 수신 동의를 철회하는 것을 피하거나 방지하기 위한 조치 <br>' +
    '' +
    'b. 번호, 기호 또는 문자를 조합하여 전화번호 또는 이메일 주소 등 수신인의 연락처를 자동으로 생성하는 조치 <br>' +
    '' +
    'c. 상업광고 정보의 전송을 목적으로 전화번호 또는 이메일 주소를 자동으로 등록하는 조치 <br>' +
    '' +
    'd. 광고정보의 송신자 또는 광고송신원의 신원을 숨기기 위한 각종 조치 <br>' +
    '' +
    'e. 상업광고 정보의 전송을 목적으로 수신자를 기망하여 대응을 유도하기 위한 각종 조치 <br>' +
    '' +
    '' +
    '' +
    '제17조(개인정보 조회 및 수집 동의 철회) <br><br>' +
    '1. 이용자 및 법정대리인은 언제든지 자신의 등록된 개인정보를 열람 또는 수정할 수 있으며, 개인정보 수집에 대한 동의 철회를 요청할 수 있습니다. <br>' +
    '2. 이용자 및 법정대리인은 개인정보보호책임자 또는 담당자에게 서면, 전화, 이메일 등으로 연락하여 본인의 가입정보 수집 등에 대한 동의를 철회할 수 있으며, 회사는 지체 없이' +
    '조치를 취하게 됩니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제18조(개인정보 등의 변경) <br><br>' +
    '1. 이용자는 위에서 설명한 방법을 통해 회사에 개인정보 오류 정정을 요청할 수 있습니다. <br>' +
    '2. 전항의 경우 개인정보 정정이 완료될 때까지 개인정보를 이용하거나 제공하지 않으며, 이미 제3자에게 잘못된 개인정보를 제공한 경우에는 지체 없이 정정 결과를 제3자에게 통보하여' +
    '정정하도록 하겠습니다. <br>' +
    '' +
    '<br><br><br>' +
    '' +
    '제19조(이용자 의무) <br><br>' +
    '1. 이용자는 개인 정보를 최신 상태로 유지해야 하며, 부정확한 정보를 입력하여 발생하는 모든 문제에 대한 책임이 있습니다. <br>' +
    '2. 타인의 개인정보를 이용하여 회원가입을 할 경우 이용자 지위를 상실하거나 관련 개인정보보호법에 따라 처벌을 받을 수 있습니다. <br>' +
    '3. 이용자는 이메일 주소, 비밀번호 등의 보안을 유지할 책임이 있으며, 제3자에게 양도 또는 대여할 수 없습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제20조(개인정보 유출 등에 대한 조치) <br><br>' +
    '회사는 개인정보의 분실·도난·유출(이하 "누출 등"이라 한다) 사실을 알게 된 때에는 즉시 이용자에게 다음 사항을 모두 고지하고 방송통신위원회 또는 한국인터넷진흥원에 신고할' +
    '예정입니다. <br>' +
    '1. 유출된 개인정보 항목 등. <br>' +
    '2. 누출 등이 발생한 경우 <br>' +
    '3. 이용자가 수행할 수 있는 작업 <br>' +
    '4. 정보통신서비스 제공자 등의 대응조치. <br>' +
    '5. 이용자가 상담 등을 받을 수 있는 부서 및 연락처.' +
    '' +
    '<br><br><br>' +
    '' +
    '제21조(개인정보 유출 등에 대한 조치의 예외) <br>' +
    '당사는 전항에도 불구하고 이용자의 연락처를 알지 못하는 등 정당한 사유가 있는 경우 30일 이상 당사 홈페이지에 공지사항을 게시하여 전항에 제공된 공지사항을 대체하는 조치를 취할' +
    '수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제22조(쿠키 설치에 대한 이용자의 선택) <br><br>' +
    '1. 이용자는 쿠키를 설치할 수 있는 옵션이 있습니다. 따라서 이용자는 웹 브라우저에서 옵션을 설정하여 모든 쿠키를 허용하거나 쿠키가 저장될 때마다 확인하거나 모든 쿠키 저장을' +
    '거부할 수 있습니다. <br>' +
    '2. 하지만 쿠키 보관을 거부할 경우 로그인이 필요한 회사의 일부 서비스를 이용하는 데 어려움을 겪을 수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제23조(쿠키의 설치 권한을 명시하는 방법) <br><br>' +
    '다음은 쿠키 설치 허용 여부를 지정하는 방법입니다: <br>' +
    '1. [도구] 메뉴에서 [인터넷 옵션]을 선택합니다. <br>' +
    '2. [Privacy] 탭을 클릭합니다. <br>' +
    '3. [Advanced] 설정에서 설정할 수 있습니다.' +
    '' +
    '<br><br><br>' +
    '' +
    '제24조(회사의 개인정보보호책임자 지정) <br><br>' +
    '회사는 이용자의 개인정보를 보호하고 개인정보와 관련된 민원을 처리하기 위해 관련 부서 및 개인정보보호관을 다음과 같이 지정합니다. <br>' +
    '1. 개인정보보호관' +
    '<br>' +
    'a. 이름 : 강태훈' +
    '<br>' +
    'b. 전화번호 : 070-8065-2292' +
    '<br>' +
    'c. 이메일 : taehoonkang@giftifan.com' +
    '<br>' +
    '<br><br>' +
    '부칙' +
    '<br>' +
    '제1조 이 정책은 2023.08.01부터 시행합니다.',
  en:
    '<h4>Privacy Policy</h4>' +
    '<br><br>' +
    '<div>' +
    'Privacy Policy' +
    '<br><br>' +
    '' +
    'Article 1 (Purpose)' +
    '<br>' +
    'globewave Co., Ltd. (hereinafter referred to as “Company”) protects the information (hereinafter' +
    '“personal information”) of individuals (hereinafter “users” or “individuals”) who use the services' +
    '(hereinafter “company services”) that the company seeks to provide. In order to comply with relevant' +
    'laws such as the Personal Information Protection Act and the Act on Promotion of Information and' +
    'Communications Network Utilization and Information Protection, etc. (hereinafter referred to as the' +
    "'Information and Communications Network Act'), and to promptly and smoothly handle service users'" +
    'grievances related to personal information protection. We establish a personal information' +
    'processing policy (hereinafter referred to as “this policy”) as follows.' +
    '<br>' +
    '<br>' +
    'Article 2 (Principles of personal information processing)' +
    '<br>' +
    "In accordance with personal information-related laws and this policy, the company may collect users'" +
    'personal information, and the collected personal information may be provided to third parties only' +
    "with the individual's consent. However, if legally enforced by laws, regulations, etc., the company" +
    "may provide the collected user's personal information to a third party without the individual's" +
    'prior consent.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 3 (Disclosure of this policy)' +
    '<br>' +
    '1. The company discloses this policy through the first screen of the company website or a link to' +
    'the first screen so that users can easily check this policy at any time.' +
    '<br>' +
    '2. When the company discloses this policy in accordance with Paragraph 1, it uses font size, color,' +
    'etc. to allow users to easily check this policy.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 4 (Changes to this policy)' +
    '<br>' +
    '1. This policy may be revised in accordance with changes in personal information-related laws,' +
    'guidelines, notices, or policies or contents of government or company services.' +
    '<br>' +
    '2. If the company revises this policy in accordance with Paragraph 1, it will announce it in one or' +
    'more of the following ways.' +
    '<br>' +
    '&nbsp;&nbsp;1. Method of making announcements through the notice section on the first screen of the' +
    "company's Internet homepage or through a separate window" +
    '<br>' +
    '&nbsp;&nbsp;2. Method of notifying users in writing, facsimile, e-mail, or similar methods.' +
    '<br>' +
    '3. The company will announce the notice in Paragraph 2 at least 7 days prior to the effective date' +
    'of the revision to this policy. However, if there are significant changes to user rights, notice' +
    'will be provided at least 30 days in advance.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 5 (Information for membership registration)' +
    '<br>' +
    "The company collects the following information to enable users to register for the company's" +
    'services.' +
    '<br>' +
    '1. Required collected information: email address and nickname' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 6 (Information for providing company services)' +
    '<br>' +
    "The company collects the following information to provide the company's services to users." +
    '<br>' +
    '1. Required collected information: ID and email address' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 7 (Information to confirm service use and fraudulent use)' +
    '<br>' +
    "The company collects the following information to confirm and analyze users' use of the service and" +
    'misuse of the service.' +
    '<br>' +
    '1. Required collected information: Service use records' +
    '<br>' +
    '※ Unauthorized use: Unlawfully or illegally receiving economic benefits such as discount coupons or' +
    'event benefits provided by the company, such as repeatedly re-registering after withdrawing' +
    'membership or canceling purchases after purchasing a product, acts prohibited by the Terms of Use,' +
    'etc., refers to illegal and illegal acts such as identity theft. The information collected may be' +
    'used for statistics and analysis based on the use of company services.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 8 (Personal Information Collection Method)' +
    '<br>' +
    'The company collects users’ personal information in the following ways.' +
    '<br>' +
    '1. How users enter their personal information on the company’s website' +
    '<br>' +
    '2. A method in which users enter their personal information through services other than the website' +
    'provided by the company, such as applications.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 9 (Use of personal information)' +
    '<br>' +
    'The company uses personal information in the following cases.' +
    '<br>' +
    '1. To improve services for users, such as responding to usage inquiries and handling complaints' +
    '<br>' +
    '2. To provide the company’s services' +
    '<br>' +
    '3. For analysis of demographic analysis, service visit and use records' +
    '<br>' +
    '4. To prevent and sanction actions that interfere with the smooth operation of the service,' +
    'including restrictions on use of members who violate laws and company terms and conditions, and' +
    'fraudulent use.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 10 (Retention and use period of personal information)' +
    '<br>' +
    '1. The company retains and uses personal information of users for the period to achieve the purpose' +
    'of collection and use of personal information.' +
    '<br>' +
    "2. Notwithstanding the preceding paragraph, in accordance with the company's internal policy," +
    'records of illegal service use are kept for up to one year from the time of membership withdrawal to' +
    'prevent illegal registration and use.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 11 (Retention and use period of personal information in accordance with laws)' +
    '<br>' +
    'The company retains and uses personal information as follows in accordance with relevant laws and' +
    'regulations.' +
    '<br>' +
    '1. Information and retention period in accordance with the Act on Consumer Protection in Electronic' +
    'Commerce, etc.' +
    '<br>' +
    '&nbsp;&nbsp;1. Records on contracts or cancellation of subscription, etc.: 5 years' +
    '<br>' +
    '&nbsp;&nbsp;2. Records of payment and supply of goods, etc.: 5 years' +
    '<br>' +
    '&nbsp;&nbsp;3. Records of consumer complaints or dispute resolution: 3 years' +
    '<br>' +
    '&nbsp;&nbsp;4. Records regarding labeling and advertising: 6 months' +
    '<br>' +
    '2. Information retained and retention period according to the Communications Secrets Protection Act' +
    '<br>' +
    '&nbsp;&nbsp;1. Website log data: 3 months' +
    '<br>' +
    '3. Information and retention period according to the Electronic Financial Transactions Act' +
    '<br>' +
    '&nbsp;&nbsp;1. Records of electronic financial transactions: 5 years' +
    '<br>' +
    '4. Act on the protection and use of location information, etc.' +
    '<br>' +
    '&nbsp;&nbsp;1. Records of personal location information: 6 months' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 12 (Principle of destruction of personal information)' +
    '<br>' +
    'In principle, when personal information is no longer needed, such as when the purpose of processing' +
    "a user's personal information has been achieved or when the retention/use period has expired, the" +
    'company destroys the information without delay.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 13 (Processing of personal information for non-users of the service)' +
    '<br>' +
    '1. In principle, the company notifies users in advance of the personal information of users who have' +
    "not used the company's services for one year and destroys or stores the personal information" +
    'separately.' +
    '<br>' +
    '2. The company will separately and safely store the personal information of users who have not used' +
    'it for a long period of time, and notification of such users will be sent to their e-mail address at' +
    'least 30 days prior to the date of separation and processing.' +
    '<br>' +
    '3. Users who have not used the service for a long period of time may log in to the website' +
    '(including the ‘mobile app’) if they wish to continue using the service before the company separates' +
    'the DB for non-users.' +
    '<br>' +
    '4. Users who have not used the service for a long period of time can restore their account with the' +
    "user's consent when logging in to the website." +
    '<br>' +
    '5. The company destroys separately stored personal information without delay after storing it for 4' +
    'years.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 14 (Personal Information Destruction Procedure)' +
    '<br>' +
    '1. The information entered by the user for membership registration, etc. is transferred to a' +
    'separate DB (in the case of paper, a separate filing cabinet) after the purpose of personal' +
    'information processing is achieved and stored (retention and retention) in accordance with the' +
    'internal policy and other relevant laws and regulations. (See period of use) It is stored for a' +
    'certain period of time and then destroyed.' +
    '<br>' +
    '2. The company destroys personal information for which there is a reason for destruction through the' +
    'approval process of the personal information protection manager.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 15 (Method of destroying personal information)' +
    '<br>' +
    'The company deletes personal information stored in electronic file format using technical methods' +
    'that render the record unrecoverable, and personal information printed on paper is destroyed by' +
    'shredding or incineration.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 16 (Measures to transmit advertising information)' +
    '<br>' +
    '1. When transmitting advertising information for commercial purposes using electronic transmission' +
    "media, the company obtains the user's explicit prior consent. However, prior consent will not be" +
    'obtained in any of the following cases:' +
    '<br>' +
    '&nbsp;&nbsp;1. If the company collects contact information directly from the recipient through a' +
    'transaction relationship for goods, etc., the company processes it within 6 months from the end of' +
    'the transaction and intends to transmit for-profit advertising information about goods of the same' +
    'type as those transacted with the recipient. case' +
    '<br>' +
    '&nbsp;&nbsp;2. When a telephone solicitation seller pursuant to the Act on Door-to-door Sales, etc.' +
    'informs the recipient of the source of personal information collection and makes a telephone' +
    'solicitation.' +
    '<br>' +
    '2. Notwithstanding the preceding paragraph, if the recipient expresses an intention to refuse' +
    'receipt or withdraws prior consent, the Company will not transmit advertising information for' +
    'commercial purposes and will notify the recipient of the processing results for refusal to receive' +
    'information or withdrawal of consent.' +
    '<br>' +
    '3. Notwithstanding Paragraph 1, if the Company transmits advertising information for commercial' +
    'purposes using electronic transmission media between 9:00 PM and 8:00 AM the next day, separate' +
    'prior consent is obtained from the recipient.' +
    '<br>' +
    '4. When transmitting advertising information for commercial purposes using electronic transmission' +
    'media, the company specifically discloses the following information in the advertising information.' +
    '<br>' +
    '&nbsp;&nbsp;1. Company name and contact information' +
    '<br>' +
    '&nbsp;&nbsp;2. Indication of matters relating to refusal to receive reception or withdrawal of' +
    'consent to reception.' +
    '<br>' +
    '5. When transmitting advertising information for commercial purposes using electronic transmission' +
    'media, the Company shall not take any of the following measures.' +
    '<br>' +
    '&nbsp;&nbsp;1. Measures to avoid or prevent recipients of advertising information from refusing to' +
    'receive or withdrawing their consent to receive such information' +
    '<br>' +
    "&nbsp;&nbsp;2. Measures to automatically create the recipient's contact information, such as phone" +
    'number or e-mail address, by combining numbers, symbols, or letters' +
    '<br>' +
    '&nbsp;&nbsp;3. Measures to automatically register phone numbers or e-mail addresses for the purpose' +
    'of transmitting commercial advertising information' +
    '<br>' +
    '&nbsp;&nbsp;4. Various measures to hide the identity of the transmitter of advertising information' +
    'or the source of advertisement transmission' +
    '<br>' +
    '&nbsp;&nbsp;5. Various measures to induce a response by deceiving the recipient for the purpose of' +
    'transmitting commercial advertising information' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 17 (Withdrawal of personal information inquiry and collection consent)' +
    '<br>' +
    '1. Users and their legal representatives can view or modify their registered personal information at' +
    'any time and request withdrawal of consent to personal information collection.' +
    '<br>' +
    '2. Users and their legal representatives may withdraw their consent to the collection of their' +
    'subscription information, etc. by contacting the personal information protection manager or person' +
    'in charge in writing, by phone, or by e-mail, and the company will take action without delay.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 18 (Change of personal information, etc.)' +
    '<br>' +
    '1. Users may request the company to correct errors in personal information through the methods' +
    'described above.' +
    '<br>' +
    '2. In the case of the preceding paragraph, the company will not use or provide personal information' +
    'until the correction of personal information is completed, and if incorrect personal information has' +
    'already been provided to a third party, the company will notify the third party of the result of the' +
    'correction without delay and make the correction. We will make sure this comes true.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 19 (User Obligations)' +
    '<br>' +
    '1. Users must keep their personal information up to date, and they are responsible for any problems' +
    'that arise from entering inaccurate information.' +
    '<br>' +
    "2. If you register as a member using someone else's personal information, you may lose your user" +
    'status or be punished under relevant personal information protection laws.' +
    '<br>' +
    '3. Users are responsible for maintaining the security of their e-mail address, password, etc. and' +
    'may not transfer or rent it to a third party.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 20 (Measures against personal information leaks, etc.)' +
    '<br>' +
    'When the company becomes aware of the loss, theft, or leakage of personal information (hereinafter' +
    'referred to as “leakage, etc.”), it will immediately notify the user of all of the following matters' +
    'and report them to the Korea Communications Commission or the Korea Internet & Security Agency.' +
    '<br>' +
    '1. Personal information items that have been leaked, etc.' +
    '<br>' +
    '2. When the leak, etc. occurred' +
    '<br>' +
    '3. Actions users can take' +
    '<br>' +
    '4. Response measures by information and communication service providers, etc.' +
    '<br>' +
    '5. Department and contact information where users can receive consultation, etc.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 21 (Exceptions to measures against personal information leakage, etc.)' +
    '<br>' +
    "If there is a justifiable reason, such as not knowing the user's contact information despite the" +
    'preceding article, the Company may take action to replace the notice provided in the preceding' +
    "article by posting the notice on the Company's website for more than 30 days." +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 22 (User’s choice to install cookies)' +
    '<br>' +
    '1. Users have the option to install cookies. Therefore, users can allow all cookies by setting' +
    'options in their web browser, confirm each time a cookie is saved, or refuse to save all cookies.' +
    '<br>' +
    "2. However, if you refuse to store cookies, you may have difficulty using some of the company's" +
    'services that require login.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 23 (How to specify permission to install cookies)' +
    '<br>' +
    "Here's how to specify (for Internet Explorer) whether to allow cookies to be installed:" +
    '<br>' +
    '1. Select [Internet Options] from the [Tools] menu.' +
    '<br>' +
    '2. Click [Privacy tab].' +
    '<br>' +
    '3. You can set it in [Advanced] settings.' +
    '<br>' +
    '<br>' +
    '<br>' +
    'Article 24 (Designation of the company’s personal information protection officer)' +
    '<br>' +
    '1. In order to protect users’ personal information and handle complaints related to personal' +
    'information, the company designates the relevant departments and personal information protection' +
    'officers as follows.&nbsp&nbsp<br>' +
    '&nbsp;&nbsp;1. Personal information protection officer' +
    '<br>' +
    '&nbsp;&nbsp;&nbsp;&nbsp;1. Name : Kang Tae Hoon' +
    '<br>' +
    '&nbsp;&nbsp;&nbsp;&nbsp;2. Phone number : 070-8065-2292' +
    '<br>' +
    '&nbsp;&nbsp;&nbsp;&nbsp;3. Email : taehoonkang@giftifan.com' +
    '<br>' +
    '&nbsp;&nbsp;&nbsp;&nbsp;Supplementary provisions' +
    '<br>' +
    '<br><br>' +
    'Article 1 This policy comes into effect from 2023.08.01.',
  ja:
    '<b>第1条（目的）</b>' +
    '<br/>' +
    'グローブウェーブ株式会社（以下「当社」といいます）は、当社が提供するサービス（以下「当社サービス」といいます）を利用する個人（以下「ユーザー」または「個人」といいます）の情報（以下「個人情報」といいます）を保護するために、個人情報保護法および情報通信網の利用促進および情報保護などに関する法律（以下「情報通信網法」といいます）などの関連法令を遵守し、個人情報保護に関するユーザーの苦情を迅速かつ円滑に処理するために、個人情報処理方針（以下「本方針」といいます）を次のとおり定めます。' +
    '<br/><br/>' +
    '<b>第2条（個人情報処理の原則）</b>' +
    '<br/>' +
    '当社は、個人情報関連法令および本方針に従ってユーザーの個人情報を収集することがあり、収集された個人情報は個人の同意がある場合にのみ第三者に提供されることがあります。ただし、法令などにより法的に強制される場合、当社は個人の事前の同意なしに収集されたユーザーの個人情報を第三者に提供することがあります。' +
    '<br/><br/>' +
    '<b>第3条（本方針の公開）</b>' +
    '<br/>' +
    '1. 当社は、ユーザーがいつでも本方針を容易に確認できるよう、当社ウェブサイトの初期画面または初期画面へのリンクを通じて本方針を公開します。<br/>' +
    '2. 当社は、第1項に従って本方針を公開する際、ユーザーが本方針を容易に確認できるようフォントサイズ、色などを使用します。' +
    '<br/><br/>' +
    '<b>第4条（本方針の変更）</b>' +
    '<br/>' +
    '1. 本方針は、個人情報関連法令、ガイドライン、通知、または政府もしくは当社のサービスの方針や内容の変更に伴い改訂されることがあります。' +
    '<br/>' +
    '2. 当社が第1項に従って本方針を改訂する場合、次のいずれかまたは複数の方法で発表します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 当社インターネットホームページの初期画面の通知セクションまたは別のウィンドウを通じて発表する方法</div>' +
    '<div style="padding-left: 1rem">2. 書面、ファックス、電子メール、または類似の方法でユーザーに通知する方法</div>' +
    '3. 当社は、本方針の改訂の発効日の少なくとも7日前に第2項の通知を発表します。ただし、ユーザーの権利に重大な変更がある場合は、少なくとも30日前に通知されます。' +
    '<br/><br/>' +
    '<b>第5条（会員登録のための情報）</b>' +
    '<br/>' +
    '当社は、ユーザーが当社のサービスに登録できるようにするために、次の情報を収集します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 必須収集情報：メールアドレスとニックネーム</div><br/>' +
    '<b>第6条（当社サービス提供のための情報）</b>' +
    '<br/>' +
    '当社は、ユーザーに当社のサービスを提供するために、次の情報を収集します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 必須収集情報：IDとメールアドレス</div>' +
    '<br/>' +
    '<b>第7条（サービス利用確認と不正利用のための情報）</b>' +
    '<br/>' +
    '当社は、ユーザーのサービス利用およびサービスの不正利用を確認し分析するために、次の情報を収集します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 必須収集情報：サービス利用記録 ※ 不正使用：会員退会後の再登録や商品購入後の購入キャンセルなどを繰り返し行い、当社が提供する割引クーポンやイベント特典などの経済的利益を不法または違法に受け取ること、利用規約で禁止されている行為、なりすましなどの違法行為を指します。収集された情報は、当社サービスの利用に基づく統計および分析に使用される場合があります。</div>' +
    '<br/>' +
    '<b>第8条（個人情報収集方法）</b>' +
    '<br/>' +
    '当社は、次の方法でユーザーの個人情報を収集します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. ユーザーが当社のウェブサイトで個人情報を入力する方法<br/>2. ユーザーがアプリケーションなど、当社が提供するウェブサイト以外のサービスを通じて個人情報を入力する方法</div>' +
    '<br>' +
    '<b>第9条（個人情報の利用）</b>' +
    '<br/>' +
    '当社は、次の場合に個人情報を利用します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 利用問い合わせへの対応や苦情処理など、ユーザーのためのサービス向上 <br/>2. 当社のサービス提供 <br/>3. 人口統計分析、サービス訪問および利用記録の分析 <br/>4. 法律および当社規約に違反する会員の利用制限や不正使用など、サービスの円滑な運営を妨げる行為の防止および制裁</div>' +
    '<br/>' +
    '<b>第10条（個人情報の保持および利用期間）</b>' +
    '<br/>' +
    '1. 当社は、個人情報の収集および利用目的を達成するための期間、ユーザーの個人情報を保持および利用します。' +
    '<br/>' +
    '2. 前項にかかわらず、当社の内部方針に従い、不正登録および利用を防止するために、会員退会時から最大1年間、違法なサービス利用の記録が保管されます。' +
    '<br/><br/>' +
    '<b>第11条（法律に基づく個人情報の保持および利用期間）</b>' +
    '<br/>' +
    '当社は、関連法令に従って次のとおり個人情報を保持および利用します。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 電子商取引等における消費者保護法に基づく情報および保持期間</div>' +
    '<div style="padding-left: 2rem">1.契約または購読キャンセル等に関する記録：5年<br/>' +
    '2. 商品等の支払いおよび供給に関する記録：5年<br/>' +
    '3.消費者苦情または紛争解決に関する記録：3年<br/>' +
    '4.表示および広告に関する記録：6ヶ月</div>' +
    '<div style="padding-left: 1rem">2. 通信秘密保護法に基づく保持情報および保持期間</div>' +
    '<div style="padding-left: 2rem">1. ウェブサイトログデータ：3ヶ月</div>' +
    '<div style="padding-left: 1rem">3. 電子金融取引法に基づく情報および保持期間</div>' +
    '<div style="padding-left: 2rem">1. 電子金融取引の記録：5年</div>' +
    '<div style="padding-left: 1rem">4. 位置情報の保護および利用に関する法律等</div>' +
    '<div style="padding-left: 2rem">1. 個人位置情報の記録：6ヶ月</div>' +
    '<br/>' +
    '<b>第12条（個人情報破棄の原則）</b>' +
    '<br/>' +
    '原則として、ユーザーの個人情報処理目的が達成されたときや保持/利用期間が満了したときなど、個人情報が不要になった場合、当社は遅滞なく情報を破棄します。' +
    '<br/><br/>' +
    '<b>第13条（サービス非利用者の個人情報の処理）</b>' +
    '<br/>' +
    '1. 原則として、当社は、1年間当社のサービスを利用していないユーザーの個人情報について事前に通知し、個人情報を破棄または別途保管します。<br/>' +
    '2. 当社は、長期間利用していないユーザーの個人情報を別途安全に保管し、そのようなユーザーへの通知は、分離および処理日の少なくとも30日前にそのメールアドレスに送信されます。<br/>' +
    '3. 長期間サービスを利用していないユーザーは、当社が非ユーザー用のDBを分離する前にサービスの利用を継続したい場合、ウェブサイト（「モバイルアプリ」を含む）にログインすることができます。<br/>' +
    '4. 長期間サービスを利用していないユーザーは、ウェブサイトにログインする際にユーザーの同意を得てアカウントを復元することができます。<br/>' +
    '5. 当社は、別途保管した個人情報を4年間保管した後、遅滞なく破棄します。' +
    '<br/><br/>' +
    '<b>第14条（個人情報破棄手順）</b>' +
    '<br/>' +
    '1. 会員登録などのためにユーザーが入力した情報は、個人情報処理の目的が達成された後、別のDB（紙の場合は別のファイリングキャビネット）に移され、内部方針およびその他関連法令に従って保管（保持および保管）されます。（利用期間を参照）一定期間保管された後、破棄されます。<br/>' +
    '2. 当社は、個人情報保護責任者の承認プロセスを通じて破棄理由がある個人情報を破棄します。' +
    '<br/><br/>' +
    '<b>第15条（個人情報の破棄方法）</b>' +
    '<br/>' +
    '当社は、電子ファイル形式で保存された個人情報を記録が復元不可能となる技術的方法で削除し、紙に印刷された個人情報は細断または焼却により破棄します。' +
    '<br/><br/>' +
    '<b>第16条（広告情報の送信に関する措置）</b>' +
    '<br/>' +
    '1. 商業目的で電子送信メディアを使用して広告情報を送信する場合、当社はユーザーの明示的な事前同意を得ます。ただし、次のいずれかの場合には事前の同意を得ません。' +
    '<div style="padding-left: 1rem">1. 受信者との商品等の取引関係を通じて直接連絡先情報を収集し、取引終了から6ヶ月以内に処理し、受信者と取引した商品と同じ種類の商品について営利的広告情報を送信しようとする場合<br/>' +
    '2. 訪問販売法に基づく電話勧誘販売者が、個人情報収集源を受信者に通知し、電話勧誘を行う場合</div>' +
    '2. 前項にかかわらず、受信者が受信拒否の意思表示または事前同意を撤回した場合、当社は商業目的の広告情報を送信せず、受信情報の拒否または同意撤回に関する処理結果を受信者に通知します。<br/>' +
    '3. 第1項にかかわらず、当社が電子送信メディアを使用して午後9時から翌日午前8時までの間に商業目的の広告情報を送信する場合、受信者から別途事前同意を得ます。<br/>' +
    '4. 電子送信メディアを使用して商業目的の広告情報を送信する場合、当社は広告情報に次の情報を具体的に開示します。<br/>' +
    '<div style="padding-left: 1rem">1. 会社名と連絡先情報<br/>' +
    '2. 受信拒否または受信同意撤回に関する事項の表示</div>' +
    '5. 電子送信メディアを使用して商業目的の広告情報を送信する場合、当社は次のいずれの措置も講じません。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. 広告情報の受信者が受信を拒否したり、受信に対する同意を撤回したりすることを回避または防止する措置<br/>' +
    '2. 数字、記号、または文字を組み合わせて、電話番号やメールアドレスなどの受信者の連絡先情報を自動的に作成する措置<br/>' +
    '3. 商業広告情報を送信する目的で電話番号やメールアドレスを自動的に登録する措置<br/>' +
    '4. 広告情報の送信者または広告送信のソースの身元を隠す様々な措置<br/>' +
    '5. 商業広告情報を送信する目的で受信者を欺いて応答を誘導する様々な措置</div>' +
    '<br/>' +
    '<b>第17条（個人情報照会および収集同意の撤回）</b>' +
    '<br/>' +
    '1. ユーザーおよびその法定代理人は、登録された個人情報をいつでも閲覧または修正し、個人情報収集への同意撤回を要求することができます。<br/>' +
    '2. ユーザーおよびその法定代理人は、個人情報保護責任者または担当者に書面、電話、または電子メールで連絡することにより、サブスクリプション情報などの収集に対する同意を撤回することができ、当社は遅滞なく対応します。' +
    '<br/><br/>' +
    '<b>第18条（個人情報の変更等）</b>' +
    '<br/>' +
    '1. ユーザーは、上記の方法を通じて個人情報の誤りの訂正を当社に要求することができます。<br/>' +
    '2. 前項の場合、当社は個人情報の訂正が完了するまで個人情報を使用または提供せず、不正確な個人情報がすでに第三者に提供されている場合、当社は訂正結果を遅滞なく第三者に通知し、訂正が行われるようにします。' +
    '<br/><br/>' +
    '<b>第19条（ユーザーの義務）</b>' +
    '<br/>' +
    '1. ユーザーは自身の個人情報を最新の状態に保つ必要があり、不正確な情報の入力から生じる問題については自身で責任を負います。<br/>' +
    '2. 他人の個人情報を使用して登録した場合、ユーザーステータスを失うか、関連する個人情報保護法の下で罰せられることがあります。<br/>' +
    '3. ユーザーは自身のメールアドレス、パスワードなどの安全性を維持する責任があり、これを第三者に譲渡または貸与してはなりません。' +
    '<br/><br/>' +
    '<b>第20条（個人情報漏洩等に対する措置）</b>' +
    '<br/>' +
    '当社は、個人情報の紛失、盗難、または漏洩（以下「漏洩等」という）を認識した場合、直ちにユーザーに次のすべての事項を通知し、韓国通信委員会または韓国インターネット＆セキュリティ庁に報告します。' +
    '<div style="padding-left: 1rem">1. 漏洩等があった個人情報項目<br/>' +
    '2. 漏洩等が発生した時期<br/>' +
    '3. ユーザーが取ることができる行動<br/>' +
    '4. 情報通信サービスプロバイダー等による対応措置<br/>' +
    '5. ユーザーが相談等を受けることができる部門および連絡先情報</div>' +
    '<br/>' +
    '<b>第21条（個人情報漏洩等に対する措置の例外）</b>' +
    '<br/>' +
    '正当な理由がある場合、例えば前条にもかかわらずユーザーの連絡先情報が分からない場合、当社は前条で定められた通知に代えて、当社のウェブサイトに30日以上通知を掲載することにより対応することがあります。' +
    '<br/><br/>' +
    '<b>第22条（クッキーのインストールに関するユーザーの選択）</b>' +
    '<br/>' +
    '1. ユーザーはクッキーをインストールするかどうかを選択できます。したがって、ユーザーはウェブブラウザのオプション設定によりすべてのクッキーを許可したり、クッキーが保存されるたびに確認したり、すべてのクッキーの保存を拒否したりすることができます。<br/>' +
    '2. ただし、クッキーの保存を拒否すると、ログインが必要な当社のサービスの一部を利用するのが難しくなる場合があります。' +
    '<br/><br/>' +
    '<b>第23条（クッキーのインストール許可を指定する方法）</b>' +
    '<br/>' +
    'クッキーのインストールを許可するかどうかを指定する方法（Internet Explorerの場合）は次のとおりです。' +
    '<br/>' +
    '<div style="padding-left: 1rem">1. [ツール]メニューから[インターネットオプション]を選択します。<br/>' +
    '2. [プライバシータブ]をクリックします。<br/>' +
    '3. [詳細設定]で設定できます。</div>' +
    '<br/>' +
    '<b>第24条（当社の個人情報保護責任者の指定）</b>' +
    '<br/>' +
    '1. ユーザーの個人情報を保護し、個人情報に関する苦情を処理するために、当社は関連部門および個人情報保護責任者を次のとおり指定します。 <br/>' +
    '<div style="padding-left: 1rem">1. 個人情報保護責任者</div>' +
    '<div style="padding-left: 2rem">1. 氏名：カン・テフン<br/>' +
    '2. 電話番号：070-8065-2292<br/>' +
    '3. メール：taehoonkang@giftifan.com</div>' +
    '<br/>' +
    '<b>附則<br/>第1条</b>' +
    '<br/>' +
    '本方針は2023年8月1日から有効となります。',
};

const refundTerm = {
  ko:
    '<h4>환불 정책</h4>' +
    '<div>' +
    '<br/><br/>- 고객 귀책사유로 인한 단순변심 반품 시 배송비 차감 후 환불 될 예정이며, 차감배송비는 최초 배송비 포함 여부에 따라 상이할 수 있습니다.(배송비 무료)<br/><br/>- 상품 수령 후 교환 및 환불은 14일 이내에 신청 가능하며 다음 사항에 해당되는 경우 교환/반품이 불가합니다.<br/> 1) 교환/반품 가능 기간이 경과된 경우<br/> 2) 복제가 가능한 상품 등의 포장을 훼손한 경우 : 예) CD/LP, DVD/Blu-ray, 소프트웨어,     만화책, 잡지, 영상 화보집<br/> 3) 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우<br/><br/>- 사전 교환/반품 접수 없이 반송하거나, 직접 발송하실 경우는 처리 및 응대가 불가합니다.  홈페이지 우측 하단 이모티콘(CS 센터) 에 우선 접수 부탁 드립니다.<br/><br/>- 주문 완료 후 여러 주문의 합포장 및 합배송은 불가합니다.<br/><br/>- 주문 완료 후 타 상품 및 옵션 변경 불가합니다. 취소 후 재 주문 부탁드립니다.<br/><br/>- 교환, 환불은 반품 상품이 도착된 이후 처리 가능하며, 맞교환 또는 타 상품 교환은 불가합니다.<br/><br/>- 그 외 전자상거래등에서의 소비자보호에 관한 법률에 규정되어 있는 소비자 청약철회 가능범위에 해당하는 경우 교환/반품이 가능합니다.<br/><br/>- 해외에서 국내로 상품을 배송하는 해외구매대행서비스의 경우 전자상거래 등에서의 소비자보호에 관한 법률 제17조 2항 5호 및 동법시행령 제21조에 의하여 반품 및 교환이 제한될 수 있습니다.' +
    '</div>',
  en:
    '<h4>Refund policy</h4>' +
    '<div>' +
    '· The expiration date of goods 1-year after purchase. ' +
    '<br><br>' +
    '· The expiration date can be checked through the purchase history.  ' +
    '<br><br>' +
    '· If goods is refunded within 7 days, you can contact the customer center for verification of identity and process a refund excluding a refund fee of 10% of the refunded amount.  ' +
    '<br><br>' +
    'However, refunds are not possible after 7 days from the purchase date.  ' +
    '<br><br>' +
    '· For cancellation of goods through in-app purchases, please contact the customer center of the respective platforms: Google Play, Apple, ONE store.  ' +
    '<br><br>' +
    '· If a minor purchases goods or services through the site without the consent of their legal guardian, the minor or legal guardian may cancel the contract. (Only Korea) ' +
    '<br><br>' +
    '· For any other inquiries or questions, please contact the customer center or refer to the terms and conditions. ' +
    '' +
    '' +
    '<br><br><br>' +
    'Company name : globewave Co., Ltd. ' +
    '<br>' +
    'Representative : KANG TAE HOON ' +
    '<br>' +
    'Business registration number : 741-87-02551 ' +
    '<br>' +
    'Mail-order Business Report : 2023-부산강서구-1110호 ' +
    '<br>' +
    'Phone Number : 070-8065-2292  ' +
    '<br>' +
    'E-Mail : support@giftifan.com ' +
    '<br>' +
    '1304, CF-F17, Centum Jungang-ro 48, Haeundae-gu, Busan, Republic of Korea  </div>',
  ja:
    '· 商品の有効期限は購入後1年間です。<br/>' +
    '· 有効期限は購入履歴から確認できます。<br/>' +
    '· 商品購入から7日以内の返金については、カスタマーセンターに連絡して本人確認を行い、返金額の10%の返金手数料を除いた金額で返金処理が可能です。ただし、購入日から7日経過後の返金はできません。<br/>' +
    '· アプリ内購入による商品のキャンセルについては、各プラットフォーム（Google Play、Apple、ONEストア）のカスタマーセンターにお問い合わせください。<br/>' +
    '· 未成年者が法定代理人の同意なくサイトを通じて商品またはサービスを購入した場合、未成年者または法定代理人は契約を取り消すことができます。（韓国のみ）<br/>' +
    '· その他のお問い合わせや質問については、カスタマーセンターにお問い合わせいただくか、利用規約をご参照ください。<br/><br/>' +
    '会社名：グローブウェーブ株式会社<br/>' +
    '代表者：カン・テフン<br/>' +
    '事業者登録番号：741-87-02551<br/>' +
    '通信販売業登録：2023-釜山江西区-1110号<br/>' +
    '電話番号：070-8065-2292<br/>' +
    'Eメール：<a href="mailto:support@giftifan.com">support@giftifan.com</a><br/>' +
    '住所：大韓民国 釜山広域市 海雲台区 センタム中央路48 CF-F17、1304',
};

const specialLaw = {
  ja:
    '<div>' +
    '1. 販売業者 : Globewave Co., Ltd' +
    '<br />' +
    '2. 運営責任者 : Taehoon Kang' +
    '<br />' +
    '3. 所在地 : 1304ho, 48, Centum jungang-ro, Haeundae-gu, Busan, Republic of Korea' +
    '<br />' +
    '4. サポート : 電話、またはメールにてサポート' +
    '<br />' +
    '電話番号 : 05068835433' +
    '<br />' +
    '6. 電話受付時間 : 10:00-18:00（土日祝を除く） ※受付時間外の場合は、メールにてお問い合わせください。' +
    '<br />' +
    '7. メールアドレス : <a href="mailto:support@giftifan.com">support@giftifan.com</a>' +
    '<br />' +
    '8. サイトURL : <a href="https://www.giftifan.com">https://www.giftifan.com</a>' +
    '<br />' +
    '9. 商品の販売価格 : 各商品ページをご参照ください。' +
    '<br />' +
    '10. 商品代金以外に必要な料金 : ・送料 : 商品の重量に応じて送料が計算され、商品購入時に一緒にお支払いいただきます。 ・振込手数料およびその他の決済手数料 : 購入者様のご負担となります。' +
    '<br />' +
    '11. 支払方法 : クレジットカード決済・コンビニ決済・銀行振込 (全て前払いのみとさせて頂いております。)' +
    '<br />' +
    '12. 支払期限 : ・クレジットカード決済 : 商品注文時にお支払いが確定します。 ・コンビニ決済・銀行振込 : 注文後1日以内にお支払いください。 ・銀行振込、郵便振込 : OOOO事務局にて確認及び入金を処理した時点 ・クレジット : 登録完了後に、即時〜3時間程度で引き渡し' +
    '<br />' +
    '13. 返品・交換 : 商品到着後 7日以内に限り返品・交換が可能です。' +
    '<br />' +
    '14. 返品送料 : ・商品に欠陥がある場合 : 当方負担 ・お客様のご都合による返品・交換の場合 : お客様負担' +
    '<br />' +
    '15. その他の条件 : 利用規約をご参照ください。' +
    '<br/>' +
    '16. 配送について :' +
    '<div style="padding-left: 1rem">16.1. 海外配送方法 : 株式会社グローブウェーブ物流センターからの直接配送（郵便局EMS）<br/>' +
    '16.2. 配送地域 : グローバル配送（配送できない地域についてはCSチームにお問い合わせください。）<br/>' +
    '16.3. 配送期間 : 決済後5〜10営業日以内<br/><div style="padding-left: 2rem">16.3.1. 予約販売の場合は、配送開始日から5〜10営業日以内。 <br/>' +
    '16.3.2. 商品の在庫状況により、配送期間が多少遅れる場合があります。 <br/>' +
    '16.3.3. 物流センターの都合により、配送が遅れることがあります。<br/>' +
    ' 16.3.4. 予約販売商品など、当日配送が難しい商品を一緒に購入する場合、すべての商品が配送可能な状態になった時点でご注文いただいた商品が一緒に配送されます。 <br/>' +
    '16.3.5. 商品ごとの配送スケジュールが異なるため、詳細なスケジュールについては商品詳細ページをご参照ください。 <br/>' +
    '16.3.6. 基本の配送期間を超える時間がかかる商品や品切れの商品については、個別にご連絡いたします。</div></div>' +
    '</div>',
};

export const termsData = {
  service: {
    ko: serviceTerm.ko,
    en: serviceTerm.en,
    ja: serviceTerm.ja,
  },
  privacy: {
    ko: privacyTerm.ko,
    en: privacyTerm.en,
    ja: privacyTerm.ja,
  },
  refund: {
    ko: refundTerm.ko,
    en: refundTerm.en,
    ja: refundTerm.ja,
  },
  specialLaw: {
    ja: specialLaw.ja,
  },
};
